import { initReactI18next, useTranslation as useTranslation$1 } from 'react-i18next';
import i18n from 'i18next';

const {
  slice,
  forEach
} = [];
function defaults(obj) {
  forEach.call(slice.call(arguments, 1), source => {
    if (source) {
      for (const prop in source) {
        if (obj[prop] === undefined) obj[prop] = source[prop];
      }
    }
  });
  return obj;
}
function hasXSS(input) {
  if (typeof input !== 'string') return false;

  // Common XSS attack patterns
  const xssPatterns = [/<\s*script.*?>/i, /<\s*\/\s*script\s*>/i, /<\s*img.*?on\w+\s*=/i, /<\s*\w+\s*on\w+\s*=.*?>/i, /javascript\s*:/i, /vbscript\s*:/i, /expression\s*\(/i, /eval\s*\(/i, /alert\s*\(/i, /document\.cookie/i, /document\.write\s*\(/i, /window\.location/i, /innerHTML/i];
  return xssPatterns.some(pattern => pattern.test(input));
}

// eslint-disable-next-line no-control-regex
const fieldContentRegExp = /^[\u0009\u0020-\u007e\u0080-\u00ff]+$/;
const serializeCookie = function (name, val) {
  let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    path: '/'
  };
  const opt = options;
  const value = encodeURIComponent(val);
  let str = `${name}=${value}`;
  if (opt.maxAge > 0) {
    const maxAge = opt.maxAge - 0;
    if (Number.isNaN(maxAge)) throw new Error('maxAge should be a Number');
    str += `; Max-Age=${Math.floor(maxAge)}`;
  }
  if (opt.domain) {
    if (!fieldContentRegExp.test(opt.domain)) {
      throw new TypeError('option domain is invalid');
    }
    str += `; Domain=${opt.domain}`;
  }
  if (opt.path) {
    if (!fieldContentRegExp.test(opt.path)) {
      throw new TypeError('option path is invalid');
    }
    str += `; Path=${opt.path}`;
  }
  if (opt.expires) {
    if (typeof opt.expires.toUTCString !== 'function') {
      throw new TypeError('option expires is invalid');
    }
    str += `; Expires=${opt.expires.toUTCString()}`;
  }
  if (opt.httpOnly) str += '; HttpOnly';
  if (opt.secure) str += '; Secure';
  if (opt.sameSite) {
    const sameSite = typeof opt.sameSite === 'string' ? opt.sameSite.toLowerCase() : opt.sameSite;
    switch (sameSite) {
      case true:
        str += '; SameSite=Strict';
        break;
      case 'lax':
        str += '; SameSite=Lax';
        break;
      case 'strict':
        str += '; SameSite=Strict';
        break;
      case 'none':
        str += '; SameSite=None';
        break;
      default:
        throw new TypeError('option sameSite is invalid');
    }
  }
  if (opt.partitioned) str += '; Partitioned';
  return str;
};
const cookie = {
  create(name, value, minutes, domain) {
    let cookieOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      path: '/',
      sameSite: 'strict'
    };
    if (minutes) {
      cookieOptions.expires = new Date();
      cookieOptions.expires.setTime(cookieOptions.expires.getTime() + minutes * 60 * 1000);
    }
    if (domain) cookieOptions.domain = domain;
    document.cookie = serializeCookie(name, value, cookieOptions);
  },
  read(name) {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  },
  remove(name, domain) {
    this.create(name, '', -1, domain);
  }
};
var cookie$1 = {
  name: 'cookie',
  // Deconstruct the options object and extract the lookupCookie property
  lookup(_ref) {
    let {
      lookupCookie
    } = _ref;
    if (lookupCookie && typeof document !== 'undefined') {
      return cookie.read(lookupCookie) || undefined;
    }
    return undefined;
  },
  // Deconstruct the options object and extract the lookupCookie, cookieMinutes, cookieDomain, and cookieOptions properties
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupCookie,
      cookieMinutes,
      cookieDomain,
      cookieOptions
    } = _ref2;
    if (lookupCookie && typeof document !== 'undefined') {
      cookie.create(lookupCookie, lng, cookieMinutes, cookieDomain, cookieOptions);
    }
  }
};

var querystring = {
  name: 'querystring',
  // Deconstruct the options object and extract the lookupQuerystring property
  lookup(_ref) {
    let {
      lookupQuerystring
    } = _ref;
    let found;
    if (typeof window !== 'undefined') {
      let {
        search
      } = window.location;
      if (!window.location.search && window.location.hash?.indexOf('?') > -1) {
        search = window.location.hash.substring(window.location.hash.indexOf('?'));
      }
      const query = search.substring(1);
      const params = query.split('&');
      for (let i = 0; i < params.length; i++) {
        const pos = params[i].indexOf('=');
        if (pos > 0) {
          const key = params[i].substring(0, pos);
          if (key === lookupQuerystring) {
            found = params[i].substring(pos + 1);
          }
        }
      }
    }
    return found;
  }
};

var hash = {
  name: 'hash',
  // Deconstruct the options object and extract the lookupHash property and the lookupFromHashIndex property
  lookup(_ref) {
    let {
      lookupHash,
      lookupFromHashIndex
    } = _ref;
    let found;
    if (typeof window !== 'undefined') {
      const {
        hash
      } = window.location;
      if (hash && hash.length > 2) {
        const query = hash.substring(1);
        if (lookupHash) {
          const params = query.split('&');
          for (let i = 0; i < params.length; i++) {
            const pos = params[i].indexOf('=');
            if (pos > 0) {
              const key = params[i].substring(0, pos);
              if (key === lookupHash) {
                found = params[i].substring(pos + 1);
              }
            }
          }
        }
        if (found) return found;
        if (!found && lookupFromHashIndex > -1) {
          const language = hash.match(/\/([a-zA-Z-]*)/g);
          if (!Array.isArray(language)) return undefined;
          const index = typeof lookupFromHashIndex === 'number' ? lookupFromHashIndex : 0;
          return language[index]?.replace('/', '');
        }
      }
    }
    return found;
  }
};

let hasLocalStorageSupport = null;
const localStorageAvailable = () => {
  if (hasLocalStorageSupport !== null) return hasLocalStorageSupport;
  try {
    hasLocalStorageSupport = typeof window !== 'undefined' && window.localStorage !== null;
    if (!hasLocalStorageSupport) {
      return false;
    }
    const testKey = 'i18next.translate.boo';
    window.localStorage.setItem(testKey, 'foo');
    window.localStorage.removeItem(testKey);
  } catch (e) {
    hasLocalStorageSupport = false;
  }
  return hasLocalStorageSupport;
};
var localStorage = {
  name: 'localStorage',
  // Deconstruct the options object and extract the lookupLocalStorage property
  lookup(_ref) {
    let {
      lookupLocalStorage
    } = _ref;
    if (lookupLocalStorage && localStorageAvailable()) {
      return window.localStorage.getItem(lookupLocalStorage) || undefined; // Undefined ensures type consistency with the previous version of this function
    }
    return undefined;
  },
  // Deconstruct the options object and extract the lookupLocalStorage property
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupLocalStorage
    } = _ref2;
    if (lookupLocalStorage && localStorageAvailable()) {
      window.localStorage.setItem(lookupLocalStorage, lng);
    }
  }
};

let hasSessionStorageSupport = null;
const sessionStorageAvailable = () => {
  if (hasSessionStorageSupport !== null) return hasSessionStorageSupport;
  try {
    hasSessionStorageSupport = typeof window !== 'undefined' && window.sessionStorage !== null;
    if (!hasSessionStorageSupport) {
      return false;
    }
    const testKey = 'i18next.translate.boo';
    window.sessionStorage.setItem(testKey, 'foo');
    window.sessionStorage.removeItem(testKey);
  } catch (e) {
    hasSessionStorageSupport = false;
  }
  return hasSessionStorageSupport;
};
var sessionStorage = {
  name: 'sessionStorage',
  lookup(_ref) {
    let {
      lookupSessionStorage
    } = _ref;
    if (lookupSessionStorage && sessionStorageAvailable()) {
      return window.sessionStorage.getItem(lookupSessionStorage) || undefined;
    }
    return undefined;
  },
  cacheUserLanguage(lng, _ref2) {
    let {
      lookupSessionStorage
    } = _ref2;
    if (lookupSessionStorage && sessionStorageAvailable()) {
      window.sessionStorage.setItem(lookupSessionStorage, lng);
    }
  }
};

var navigator$1 = {
  name: 'navigator',
  lookup(options) {
    const found = [];
    if (typeof navigator !== 'undefined') {
      const {
        languages,
        userLanguage,
        language
      } = navigator;
      if (languages) {
        // chrome only; not an array, so can't use .push.apply instead of iterating
        for (let i = 0; i < languages.length; i++) {
          found.push(languages[i]);
        }
      }
      if (userLanguage) {
        found.push(userLanguage);
      }
      if (language) {
        found.push(language);
      }
    }
    return found.length > 0 ? found : undefined;
  }
};

var htmlTag = {
  name: 'htmlTag',
  // Deconstruct the options object and extract the htmlTag property
  lookup(_ref) {
    let {
      htmlTag
    } = _ref;
    let found;
    const internalHtmlTag = htmlTag || (typeof document !== 'undefined' ? document.documentElement : null);
    if (internalHtmlTag && typeof internalHtmlTag.getAttribute === 'function') {
      found = internalHtmlTag.getAttribute('lang');
    }
    return found;
  }
};

var path = {
  name: 'path',
  // Deconstruct the options object and extract the lookupFromPathIndex property
  lookup(_ref) {
    let {
      lookupFromPathIndex
    } = _ref;
    if (typeof window === 'undefined') return undefined;
    const language = window.location.pathname.match(/\/([a-zA-Z-]*)/g);
    if (!Array.isArray(language)) return undefined;
    const index = typeof lookupFromPathIndex === 'number' ? lookupFromPathIndex : 0;
    return language[index]?.replace('/', '');
  }
};

var subdomain = {
  name: 'subdomain',
  lookup(_ref) {
    let {
      lookupFromSubdomainIndex
    } = _ref;
    // If given get the subdomain index else 1
    const internalLookupFromSubdomainIndex = typeof lookupFromSubdomainIndex === 'number' ? lookupFromSubdomainIndex + 1 : 1;
    // get all matches if window.location. is existing
    // first item of match is the match itself and the second is the first group match which should be the first subdomain match
    // is the hostname no public domain get the or option of localhost
    const language = typeof window !== 'undefined' && window.location?.hostname?.match(/^(\w{2,5})\.(([a-z0-9-]{1,63}\.[a-z]{2,6})|localhost)/i);

    // if there is no match (null) return undefined
    if (!language) return undefined;
    // return the given group match
    return language[internalLookupFromSubdomainIndex];
  }
};

// some environments, throws when accessing document.cookie
let canCookies = false;
try {
  // eslint-disable-next-line no-unused-expressions
  document.cookie;
  canCookies = true;
  // eslint-disable-next-line no-empty
} catch (e) {}
const order = ['querystring', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'];
if (!canCookies) order.splice(1, 1);
const getDefaults = () => ({
  order,
  lookupQuerystring: 'lng',
  lookupCookie: 'i18next',
  lookupLocalStorage: 'i18nextLng',
  lookupSessionStorage: 'i18nextLng',
  // cache user language
  caches: ['localStorage'],
  excludeCacheFor: ['cimode'],
  // cookieMinutes: 10,
  // cookieDomain: 'myDomain'

  convertDetectedLanguage: l => l
});
class Browser {
  constructor(services) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.type = 'languageDetector';
    this.detectors = {};
    this.init(services, options);
  }
  init() {
    let services = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
      languageUtils: {}
    };
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let i18nOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    this.services = services;
    this.options = defaults(options, this.options || {}, getDefaults());
    if (typeof this.options.convertDetectedLanguage === 'string' && this.options.convertDetectedLanguage.indexOf('15897') > -1) {
      this.options.convertDetectedLanguage = l => l.replace('-', '_');
    }

    // backwards compatibility
    if (this.options.lookupFromUrlIndex) this.options.lookupFromPathIndex = this.options.lookupFromUrlIndex;
    this.i18nOptions = i18nOptions;
    this.addDetector(cookie$1);
    this.addDetector(querystring);
    this.addDetector(localStorage);
    this.addDetector(sessionStorage);
    this.addDetector(navigator$1);
    this.addDetector(htmlTag);
    this.addDetector(path);
    this.addDetector(subdomain);
    this.addDetector(hash);
  }
  addDetector(detector) {
    this.detectors[detector.name] = detector;
    return this;
  }
  detect() {
    let detectionOrder = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.options.order;
    let detected = [];
    detectionOrder.forEach(detectorName => {
      if (this.detectors[detectorName]) {
        let lookup = this.detectors[detectorName].lookup(this.options);
        if (lookup && typeof lookup === 'string') lookup = [lookup];
        if (lookup) detected = detected.concat(lookup);
      }
    });
    detected = detected.filter(d => d !== undefined && d !== null && !hasXSS(d)).map(d => this.options.convertDetectedLanguage(d));
    if (this.services && this.services.languageUtils && this.services.languageUtils.getBestMatchFromCodes) return detected; // new i18next v19.5.0
    return detected.length > 0 ? detected[0] : null; // a little backward compatibility
  }
  cacheUserLanguage(lng) {
    let caches = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.options.caches;
    if (!caches) return;
    if (this.options.excludeCacheFor && this.options.excludeCacheFor.indexOf(lng) > -1) return;
    caches.forEach(cacheName => {
      if (this.detectors[cacheName]) this.detectors[cacheName].cacheUserLanguage(lng, this.options);
    });
  }
}
Browser.type = 'languageDetector';

var hatsuly$1 = {
	nav: {
		projectList: "Projects",
		projectSettings: "Project Settings",
		login: "Log in",
		register: "Sign up"
	},
	landing: {
		headline: "From inspection to repair,\nthrough to maintenance,\nconnected by 3D:\na new shape for infrastructure management.",
		start: "Get started"
	},
	register: {
		title: "Create a free viewer account",
		description: "Enter your email address and a free account for viewing projects will be created.\nIf you need paid features such as creating projects, sign in with your viewer account and contact us from the inquiry page.",
		email: "Email address",
		name: "Name",
		company: "Company name",
		submit: "Register",
		successTitle: "Your user account was created successfully.",
		successBody: "Check your inbox for a link to set your password."
	},
	adminViewBanner: {
		viewing: "Viewing {{user}}'s dashboard (read-only)",
		back: "Back to your dashboard"
	},
	userMenu: {
		plan: "Subscription Plan",
		userList: "User List"
	},
	stats: {
		storageUsed: "Storage Used",
		projectCount: "Projects",
		projectCountUnit: "projects",
		projectBreakdown: "Created {{owned}} · Invited {{invited}}"
	},
	tabs: {
		owned: "Created",
		invited: "Invited"
	},
	projectList: {
		searchPlaceholder: "Search projects",
		empty: "No matching projects",
		viewersUnit: "",
		create: "New Project",
		toggleAreas: "Toggle inspection areas"
	},
	area: {
		searchPlaceholder: "Search areas",
		empty: "No matching areas",
		create: "New Area"
	},
	menu: {
		projectEdit: "Edit Project",
		reportDetail: "Report Details",
		manageViewers: "Manage Viewers",
		projectDelete: "Delete Project",
		areaEdit: "Edit Area",
		openViewer: "Open Inspection Viewer",
		reportExport: "Export Report",
		alignArea: "Align Area",
		areaDelete: "Delete Area"
	},
	subscription: {
		upgradeTitle: "Upgrade to create new projects",
		upgradeBody: "A paid plan unlocks every feature — creating projects, expanded storage, point-cloud processing and more.",
		viewPlans: "View Paid Plans"
	},
	toast: {
		project: {
			created: "Project created",
			updated: "Project updated",
			deleted: "Project deleted"
		},
		area: {
			created: "Area created",
			updated: "Area updated",
			deleted: "Area deleted"
		},
		viewers: {
			invited: "Viewer invited",
			removed: "Viewer removed"
		}
	},
	columns: {
		name: "Name",
		size: "Size",
		viewers: "Viewers",
		updated: "Updated",
		created: "Created"
	},
	modal: {
		project: {
			create: {
				title: "Create Project",
				nameLabel: "Project Name",
				workTypeLabel: "Work Type",
				typeLabel: "Category",
				fieldHint: "Used as the default when creating areas. Can be changed per area."
			},
			edit: {
				title: "Edit Project"
			},
			duplicateError: "A project with this name already exists, please choose a different name.",
			"delete": {
				title: "Delete Project",
				body: "Delete \"{{name}}\"? This action cannot be undone."
			}
		},
		area: {
			add: {
				title: "Add Area",
				projectLabel: "Project",
				nameLabel: "Area Name",
				dataSection: "Data",
				pointCloud: "Point Cloud",
				pointCloudFormats: ".las / .laz / .ply",
				mesh: "3D Mesh",
				meshFormats: ".zip",
				chooseFile: "Choose a file",
				orDrop: " or drop it here",
				inspectionSection: "Inspection Details",
				optional: "Optional",
				workTypeLabel: "Work Type",
				typeLabel: "Category",
				authorLabel: "Author",
				createdDateLabel: "Created Date",
				witnessLabel: "Witness",
				witnessDateLabel: "Witness Date"
			},
			edit: {
				title: "Edit Area",
				shapesExistError: "Rebars or planes have already been detected on this area. Delete them before replacing the point cloud."
			},
			"delete": {
				title: "Delete Area",
				body: "Delete \"{{name}}\"? This action cannot be undone."
			}
		},
		viewers: {
			title: "Viewers",
			emailColumn: "Email Address",
			invite: "Invite Viewer",
			inviteEmailLabel: "Email address to invite",
			emailPlaceholder: "name@example.com",
			send: "Send",
			empty: "No viewers yet"
		},
		tos: {
			agree: "Agree and Continue"
		}
	},
	footer: {
		copyright: "© 2024 DataLabs Inc.",
		manual: "User Manual",
		terms: "Terms of Service",
		contact: "Contact"
	},
	userList: {
		columns: {
			user: "User",
			hubspot: "HubSpot",
			subscriptionEnd: "Subscription End",
			billing: "Billing / Agency"
		},
		sortNext: "Click to change the order (descending, ascending, unsorted)",
		sortUnsorted: "Unsorted — click to sort by subscription end, newest first",
		searchPlaceholder: "Search by Auth0 email (app login)",
		clearSearch: "Clear search",
		editHubspotId: "Edit HubSpot ID",
		refetch: "Refresh",
		save: "Save changes",
		saved: "Changes saved",
		saveError: "Failed to save changes",
		unsaved: "Unsaved",
		undoChange: "Undo this change",
		hubspotIdPlaceholder: "HubSpot ID",
		noHubspotId: "No ID",
		noHubspotEmail: "No email linked",
		noInfo: "No info",
		legacyPlan: "Legacy plan: {{plan}}",
		prevPage: "Previous",
		nextPage: "Next",
		empty: "No matching users"
	}
};
var maintenance$1 = {
	heading: "Under Maintenance",
	body: "The system is currently undergoing maintenance and is temporarily unavailable. We apologize for the inconvenience—please wait until it is complete.",
	about: "About 3D InfraLoop"
};
var nav$1 = {
	hierarchy: "Contractee → Route → Facility → Timeline",
	administrators: "Administrators",
	routes: "Routes"
};
var dashboard$1 = {
	_single: "Dashboard",
	title: "Infrastructure Dashboard",
	subtitle: "Overview of All Facilities and Inspection Events",
	sections: {
		recentEvents: "Recent Events",
		attentionRequired: "Facilities Requiring Attention",
		allFacilities: "All Facilities"
	},
	returnToDashboard: "Return to Dashboard",
	attentionRequired: {
		emptyState: "There are currently no facilities requiring attention."
	},
	allFacilities: {
		emptyState: "No facilities found."
	},
	recentEvents: {
		emptyState: "No events found."
	}
};
var userAccount$1 = {
	account: {
		title: "Account"
	},
	inspectionSheet: {
		title: "Inspection Sheet Settings"
	},
	editor: {
		title: "3D View Settings"
	},
	plan: {
		title: "Billing Information"
	},
	comingSoon: {
		title: "Coming soon",
		description: "{{label}} will be available soon."
	},
	backToDashboard: "Back to Dashboard"
};
var object$1 = {
	facility: {
		_single: "Facility",
		list: "Facility List",
		add: "Add Facility",
		name: "Facility Name",
		id: "Facility ID",
		year: "Completion Year",
		kilopostStart: "Kilopost Start",
		kilopostEnd: "Kilopost End",
		type: {
			_single: "Facility Type",
			tunnel: "Tunnel",
			bridge: "Bridge",
			culvert: "Culvert",
			shed: "Shed",
			overpass: "Overpass",
			other: "Other"
		},
		latitude: "Latitude",
		longitude: "Longitude",
		coordinates: "Coordinates",
		prefectureCode: "Prefecture Code",
		municipalityCode: "Municipality Code",
		address: "Address",
		coordinateSystem: "Coordinate System",
		totalLength: "Total Length",
		groundwaterCondition: "Groundwater Condition",
		landslideArea: "Landslide Area",
		expansiveGround: "Expansive Ground",
		harmfulWater: "Harmful Groundwater",
		snowArea: "Snow Area",
		saltDamageArea: "Salt Damage Area",
		width: "Width",
		height: "Height",
		totalSpanCount: "Total Spans",
		liningType: "Lining Type",
		lanes: "Lanes",
		constructionMethod: "Construction Method",
		structureType: "Structure Type"
	},
	facilities: "Facilities",
	span: {
		_single: "Span",
		add: "Add Span",
		length: "Length",
		notes: "Notes",
		inspectionDate: "Inspection Date",
		judgmentBasis: "Judgment Basis",
		assessmentNotes: "Assessment Notes"
	},
	event: {
		_single: "Event",
		_plural: "Events",
		count_one: "{{count}} event",
		count_other: "{{count}} events",
		add: "Add Event",
		name: "Event Name",
		year: "Year",
		period: "Period",
		contractor: "Contractor",
		fiscalYear: "Fiscal Year",
		inspectionPeriod: "Inspection Period",
		contractorName: "Contractor Name",
		contractorCode: "Contractor Code",
		inspectionMethod: "Inspection Method",
		inspectionEquipment: "Inspection Equipment",
		weatherSummary: "Weather Summary",
		inspectionTeam: "Inspection Team",
		previousSoundness: "Previous Soundness",
		soundnessRatingBasis: "Soundness Rating Basis",
		team: {
			role: "Role",
			name: "Name",
			qualification: "Qualification",
			qualificationId: "Qualification ID"
		}
	},
	eventType: {
		_single: "Event Type",
		periodic: "Periodic Inspection",
		emergency: "Emergency Inspection",
		followUp: "Follow Up Inspection",
		repair: "Repair Construction"
	},
	inspectionStatus: {
		_single: "Inspection Status",
		draft: "Draft",
		inProgress: "In Progress",
		completed: "Completed",
		submitted: "Submitted"
	},
	defectRecord: {
		_single: "Defect Record",
		add: "Add Defect Record",
		name: "Defect Record Name",
		elementNumber: "Element Number"
	},
	defectPhotos: {
		memo: "Memo"
	},
	construction: {
		type: "Construction Type",
		creator: "Creator",
		created_date: "Created Date",
		observer: "Observer",
		observed_date: "Observed Date"
	},
	inspectionItems: {
		_single: "Inspection Items",
		list: "Inspection Items"
	},
	inspectionArea: {
		_single: "Inspection Area",
		_plural: "Inspection Areas",
		name: "Area Name"
	},
	electronicDelivery: {
		_single: "Electronic Delivery"
	},
	deliverables: {
		_single: "Deliverable",
		_plural: "Deliverables"
	},
	approval: {
		_single: "Approval",
		pending: "Pending",
		approved: "Approved",
		rejected: "Rejected",
		submitted: "Submitted",
		registered: "Registered",
		draft: "Draft",
		revisionRequested: "Revision Requested"
	},
	files: {
		_plural: "Files",
		noPCD: "Missing PCD",
		status: {
			running: "Processing",
			succeeded: "Processed",
			failed: "Error"
		}
	},
	componentType: {
		_single: "Component Type",
		tunnel: {
			crown: "Crown/Arch",
			sidewall: "Sidewall",
			invert: "Invert",
			portal: "Portal",
			ceiling: "Ceiling Board",
			attachments: "Attachments"
		},
		bridge: {
			mainGirder: "Main Girder",
			crossBeam: "Cross Beam",
			stringer: "Stringer",
			deckSlab: "Deck Slab",
			superstructureOther: "Other Superstructure",
			pier: "Pier",
			abutment: "Abutment",
			foundation: "Foundation",
			substructureOther: "Other Substructure",
			bearing: "Bearing",
			connectionOther: "Other Connection",
			expansionJoint: "Expansion Joint",
			failSafe: "Unseating Prevention",
			curb: "Curb",
			guardrail: "Railing / Guardrail",
			drainage: "Drainage Facility",
			pavement: "Road Surface / Pavement",
			staircase: "Staircase",
			signBoard: "Sign Board",
			lighting: "Lighting Facility",
			inspectionGallery: "Inspection Gallery"
		}
	},
	defectType: {
		_single: "Defect Type",
		tunnel: {
			crack: "Crack",
			delamination: "Delamination",
			spalling: "Spalling",
			falloff: "Falloff",
			deformation: "Deformation",
			waterLeakage: "Water Leakage",
			materialDeterioration: "Material Deterioration",
			rebarExposure: "Rebar Exposure",
			cavityVoid: "Cavity/Void",
			efflorescence: "Efflorescence",
			freeLime: "Free Lime",
			rustStaining: "Rust Staining",
			honeycombing: "Honeycombing"
		},
		bridge: {
			corrosionSteel: "Steel Corrosion",
			crackSteel: "Steel Crack",
			boltLooseningFalloff: "Bolt Loosening / Falloff",
			ruptureSteel: "Steel Rupture",
			anticorrosionDeterioration: "Anticorrosion Deterioration",
			crackConcrete: "Concrete Crack",
			spallingRebarExposure: "Spalling / Rebar Exposure",
			leakageEfflorescence: "Leakage / Efflorescence",
			punchingFailure: "Punching Failure",
			reinforcementDamage: "Reinforcement Damage",
			crackDeckSlab: "Deck Slab Crack",
			delamination: "Delamination",
			jointAbnormality: "Joint Abnormality",
			roadSurfaceUnevenness: "Road Surface Unevenness",
			pavementAnomaly: "Pavement Anomaly",
			bearingDysfunction: "Bearing Dysfunction",
			other: "Other",
			anchorageAbnormality: "Anchorage Abnormality",
			materialDeterioration: "Material Deterioration",
			waterLeakagePuddling: "Water Leakage / Puddling",
			abnormalSoundVibration: "Abnormal Sound / Vibration",
			abnormalDeflection: "Abnormal Deflection",
			deformationDefect: "Deformation / Defect",
			sedimentClogging: "Sediment Clogging",
			settlementTilt: "Settlement / Tilt",
			scour: "Scour",
			none: "No Damage"
		}
	},
	assessment: {
		_single: "Assessment",
		_plural: "Assessments"
	},
	severity: {
		_single: "Severity",
		a: "No Defects",
		b: "Minor Defects",
		c: "Caution",
		d: "Emergency",
		e: "Not Inspectable",
		grade: "Severity Grade",
		descriptions: {
			a: "No Defects",
			b: "Defects are present but do not require immediate repair. Monitoring is required.",
			c: "Deterioration has progressed; countermeasures should be planned to prevent functional impairment.",
			d: "Severe defects threatening structural safety or third-party safety.",
			e: "Not Inspectable"
		}
	},
	severityChange: {
		_single: "Severity Change",
		worsened: "Worsened",
		improved: "Improved",
		unchanged: "Unchanged"
	},
	progression: {
		_single: "Progression",
		progressive: "Progressive",
		stable: "Stable",
		unknown: "Unknown"
	},
	countermeasure: {
		_single: "Countermeasure",
		A0: "No Action Required",
		A: "Monitoring Only",
		B: "Planned Maintenance",
		C: "Repair Required (Planned)",
		E1: "Emergency Repair Required",
		E2: "Emergency Measures Required",
		M: "Detailed Investigation Required (Monitoring)",
		S1: "Detailed Investigation Required",
		S2: "Cause Investigation Required",
		description: {
			A0: "Defect is negligible; no action or monitoring required.",
			A: "Monitor during subsequent inspection cycles.",
			B: "Implement planned maintenance while monitoring.",
			C: "Plan repairs before the next inspection.",
			E1: "Structural integrity may be compromised. Emergency repair required.",
			E2: "Immediate traffic restrictions or temporary support work required.",
			M: "Condition unclear. Monitor carefully and plan detailed investigation.",
			S1: "Additional investigation required, such as core sampling or load testing.",
			S2: "Cause analysis required before determining countermeasures."
		}
	},
	cause: {
		_single: "Cause",
		_plural: "Causes",
		aging_deterioration: "Aging Deterioration",
		drying_shrinkage: "Drying Shrinkage",
		thermal_stress: "Thermal Stress",
		structural_stress: "Structural Stress",
		ground_movement: "Ground Movement",
		freeze_thaw: "Freeze-Thaw",
		water_infiltration: "Water Infiltration",
		groundwater_pressure: "Groundwater Pressure",
		chloride_attack: "Chloride Attack",
		carbonation: "Carbonation",
		alkali_silica_reaction: "Alkali-Silica Reaction",
		impact_damage: "Impact Damage",
		fire_damage: "Fire Damage",
		construction_defect: "Construction Defect",
		insufficient_backfill: "Insufficient Backfill",
		joint_degradation: "Joint Degradation",
		water_erosion: "Water Erosion",
		seismic_damage: "Seismic Damage"
	},
	measurements: {
		length: "Length",
		width: "Width",
		depth: "Depth",
		area: "Area",
		volume: "Volume",
		pattern: "Pattern",
		displacement: "Displacement",
		direction: "Direction",
		level: "Level",
		flow_state: "Flow State",
		corrosion_grade: "Corrosion Grade",
		diameter: "Diameter",
		corrosion_area: "Corrosion Area",
		thickness_reduction: "Thickness Reduction",
		crack_length: "Crack Length",
		bolt_count: "Bolt Count",
		deteriorated_area: "Deteriorated Area",
		crack_width: "Crack Width",
		efflorescence_seepage: "Efflorescence / Seepage",
		exposure_area: "Exposure Area",
		section_loss: "Section Loss",
		leakage_state: "Leakage State",
		hole_area: "Hole Area",
		material_type: "Material Type",
		crack_pattern: "Crack Pattern",
		delamination_area: "Delamination Area",
		gap_width: "Gap Width",
		level_difference: "Level Difference",
		anomaly_type: "Anomaly Type",
		dysfunction_state: "Dysfunction State",
		description: "Description",
		damage_state: "Damage State",
		scour_depth: "Scour Depth"
	},
	soundnessRating: {
		_single: "Soundness Rating",
		I: "Sound",
		II: "Preventive Maintenance",
		III: "Early Measure",
		IV: "Emergency Measure",
		descriptions: {
			I: "No significant defects observed. Regular monitoring is recommended.",
			II: "Minor defects present. Preventive maintenance measures are required.",
			III: "Function is possibly impaired; measures are required before the next inspection.",
			IV: "Function is impaired or failure is imminent; immediate closure or repair is required."
		}
	}
};
var modal$1 = {
	facility: {
		namePlaceholder: "Enter facility name",
		typePlaceholder: "Select type...",
		idPlaceholder: "e.g., 38.45123,140.89456",
		add: {
			title: "New Facility",
			submit: "Create Facility",
			successMessage: "Facility created successfully!"
		},
		edit: {
			title: "Edit Facility",
			successMessage: "Successfully updated facility information.",
			basicInfo: "Basic Information",
			location: "Location Information",
			specifications: "Specifications",
			groundConditions: "Ground Conditions"
		},
		"delete": {
			confirmationTitle: "Delete Facility",
			confirmationMessage: "Are you sure you want to delete this facility? This action cannot be undone.",
			successMessage: "Successfully deleted facility."
		}
	},
	span: {
		nameLabel: "Span Name",
		namePlaceholder: "Enter span name",
		lengthPlaceholder: "Enter span length",
		notesPlaceholder: "Enter any additional notes",
		add: {
			title: "Add Span",
			submit: "Add Span",
			successMessage: "Span added successfully!",
			tabs: {
				createNew: "Create New",
				selectExisting: "Select Existing"
			},
			selectExistingDescription: "Import spans from this facility that haven't been added to this inspection yet.",
			noExisting: "All facility spans have already been added to this inspection.",
			importSuccessMessage: "Span(s) imported successfully!"
		},
		edit: {
			title: "Edit Span",
			submit: "Update Span",
			successMessage: "Span updated successfully!"
		},
		"delete": {
			confirmationTitle: "Delete Span",
			confirmationMessage: "Are you sure you want to delete this span? This action cannot be undone.",
			successMessage: "Span deleted successfully!"
		}
	},
	damagePhoto: {
		upload: {
			successMessage: "Photos uploaded successfully"
		},
		updateMemoSuccessMessage: "Memo updated successfully",
		deleteSuccessMessage: "Photo deleted successfully"
	},
	defectRecord: {
		namePlaceholder: "e.g. Member A-1",
		elementNumberPlaceholder: "e.g. Element 001",
		componentTypePlaceholder: "Select component type...",
		defectTypePlaceholder: "Select defect type...",
		add: {
			title: "Add Defect Record",
			selectExistingDescription: "Select from existing defect records...",
			noExisting: "No existing defect records found from previous inspection events for this span.",
			missingInspectionDate: "Missing inspection date",
			successMessage: "Defect record added successfully!",
			tabs: {
				createNew: "Create New",
				selectExisting: "Select Existing"
			}
		},
		edit: {
			title: "Edit Defect Record",
			warningMessage: "Changes to defect record information will affect this defect record across all inspection events",
			successMessage: "Defect record updated successfully!"
		}
	},
	event: {
		add: {
			title: "New Event",
			selectZipFile: "Select Electronic Delivery ZIP File",
			namePlaceholder: "Enter event name",
			eventTypePlaceholder: "Select type",
			contractorPlaceholder: "Enter contractor name",
			periodPlaceholder: "e.g. 2026/01/01 - 2026/03/31",
			electronicDeliveryHelperText: "Import deliverable folder structure from electronic delivery ZIP archive",
			successMessage: "Successfully created event."
		},
		edit: {
			title: "Edit Inspection Event",
			successMessage: "Successfully updated event information.",
			basicInfo: "Basic Information",
			year: "Year",
			contractorInfo: "Contractor Information",
			inspectionDetails: "Inspection Details",
			equipmentPlaceholder: "Enter equipment name",
			addItem: "Add Item",
			weatherSummaryPlaceholder: "e.g., Clear to cloudy, no rain during inspection period",
			addMember: "Add Member",
			team: {
				rolePlaceholder: "Enter role",
				namePlaceholder: "Enter name",
				qualificationPlaceholder: "Enter qualification",
				qualificationIdPlaceholder: "Enter qualification ID"
			},
			soundnessAssessment: "Soundness Assessment",
			soundnessRatingBasisPlaceholder: "Enter the basis for soundness rating determination..."
		},
		"delete": {
			confirmationTitle: "Delete Event",
			confirmationMessage: "Are you sure you want to delete this event? This action cannot be undone.",
			successMessage: "Successfully deleted event."
		}
	},
	inspectionArea: {
		add: {
			title: "Add Inspection Area",
			spanLabel: "Span",
			spanPlaceholder: "Select span...",
			areaNamePlaceholder: "Enter area name",
			areaNameDuplicateError: "An area with this name already exists, please choose a different name.",
			pcdFileLabel: "Point Cloud Data",
			pcdFileHelperText: "Select file (.las, .laz, .ply)",
			pcdFilePlaceholder: "Select PCD file...",
			meshFileLabel: "3D Mesh Data",
			meshFileHelperText: "Select file (.zip)",
			meshFilePlaceholder: "Select 3D mesh file...",
			successMessage: "Inspection area created successfully"
		},
		"delete": {
			confirmationTitle: "Delete Inspection Area",
			confirmationMessage: "Are you sure you want to delete this inspection area? This action cannot be undone.",
			successMessage: "Inspection area deleted successfully"
		}
	},
	spanAssessment: {
		create: {
			successMessage: "Span assessment created successfully!"
		},
		edit: {
			successMessage: "Span assessment updated successfully!"
		}
	},
	comment: {
		create: {
			successMessage: "Comment added successfully!"
		}
	},
	diagram: {
		upload: {
			successMessage: "Diagram uploaded successfully"
		}
	},
	diagramMarker: {
		unlink: {
			confirmationTitle: "Unlink defect record",
			confirmationMessage: "Are you sure you want to unlink this defect record? The defect record itself will not be deleted."
		}
	}
};
var section$1 = {
	overview: {
		title: "Overview",
		soundness: {
			title: "Overall Soundness Rating",
			subtitle: "Per MLIT inspection standards",
			current: "Current",
			previous: "Previous",
			worsened: "Worsened",
			improved: "Improved",
			stable: "Stable",
			judgmentBasis: "Judgment Basis"
		},
		defectBreakdown: {
			title: "Defect Breakdown",
			subtitle: "By severity grade",
			total: "Total"
		},
		actions: {
			title: "Action Required",
			itemCount_one: "{{count}} item",
			itemCount_other: "{{count}} items",
			critical: "Critical",
			criticalDesc: "Severity d or Soundness IV",
			worsened: "Worsened",
			worsenedDesc: "Severity increased since last inspection",
			viewMoreCritical: "View {{count}} more critical defects",
			viewMoreWorsened: "View {{count}} more worsened defects",
			position: "Position {{position}}"
		},
		context: {
			title: "Inspection Context",
			facilitySpecs: "Facility Specifications",
			spec: {
				type: "Type",
				length: "Length",
				method: "Method",
				built: "Built",
				lanes: "Lanes",
				spans: "Spans"
			},
			inspectionInfo: "Inspection Information",
			info: {
				period: "Period",
				method: "Method",
				equipment: "Equipment",
				contractor: "Contractor",
				team: "Team"
			},
			location: "Location",
			locationValue: "宮城県仙台市青葉区",
			mapPlaceholder: "Map (Leaflet integration pending)"
		},
		approval: {
			title: "Approval Status",
			pending: "{{count}} pending",
			actionRequired: "Action required",
			deliverablePackage: "2025 Deliverable Package",
			viewAll: "View All"
		}
	},
	inspectionItem: {
		title: "Defect Records",
		searchPlaceholder: "Search spans...",
		filters: {
			properties: "Properties"
		},
		elementAlreadyLinked: "This element is already linked to another defect record.",
		linkExistingConfirm: {
			title: "Replace existing linked/modelled inspection item?",
			description: "The selected inspection item has already been linked to another defect record ({{otherDamageName}}). \n\n Do you want to replace it with the current one ({{damageName}})?"
		},
		unlinkConfirm: {
			title: "Unlink inspection item?",
			description: "Are you sure you want to unlink the inspection item from defect record ({{damageName}})? This action cannot be undone."
		},
		emptyState: {
			title: "Start Inspection",
			description: "Add spans and record defects to begin documenting this inspection event",
			action: "Create Span",
			hint: "Create your first span to get started",
			noData: "No defect records available.",
			notFound: "No spans match your search"
		},
		detail: {
			viewHistory: "View History",
			historyUnavailable: "History is available once this defect appears in more than one inspection.",
			activity: "Activity",
			activities: "Activities",
			noActivities: "No activities yet",
			personInCharge: "Person in Charge",
			personInChargeLongDescription: "Person in Charge\n\nThe inspector or engineer responsible for this specific defect finding. In the MLIT periodic inspection workflow:\n\n• The field inspector records initial findings and severity grades.\n• A qualified bridge/tunnel inspection engineer reviews and may adjust ratings.\n• The person in charge is recorded in the inspection ledger for traceability and accountability.\n\nMLIT requires that inspection team members hold appropriate qualifications (e.g. Road Maintenance Specialist, PE qualification) and their names/license numbers are recorded in the inspection report.",
			progressionLongDescription: "Progression Assessment\n\nEvaluates whether the defect has worsened over time compared to previous inspection records. MLIT guidelines require progression assessment for all existing defects:\n\n• Progressive — Clear deterioration since the last inspection (e.g., crack width expansion, increased leakage, larger delamination area).\n• Stable — Defect exists but shows no significant change from the previous inspection cycle.\n• Unknown — No previous inspection data available for comparison, or the location was previously uninspectable.\n\nProgression is assessed after severity grading and serves as a key factor in determining individual soundness ratings. Even with the same severity grade, progressive defects may receive a higher soundness rating than stable defects.",
			soundnessRatingLongDescription: "Individual Soundness Rating (I–IV) — MLIT National Standard\n\nA technical assessment of structural safety that comprehensively considers severity grade (a–e), progression, defect location, and member importance. Each defect is individually rated (I–IV), and the most severe rating is reflected at the member and facility level:\n\n• I — Sound: No defects or minor defects that do not affect structural safety.\n• II — Preventive Maintenance: Defects present but no functional impairment. Preventive maintenance is recommended.\n• III — Early Measure: Significant defects. Measures are required before the next inspection.\n• IV — Emergency Measure: Critical defects threatening structural safety or third-party safety. Immediate action required.\n\nIf even one defect is rated III or IV, the entire span or facility is elevated to that rating. This assessment forms the basis for the countermeasure category below.",
			countermeasureLongDescription: "Countermeasure Category — MLIT Bridge/Tunnel Inspection Guidelines\n\nBased on the soundness assessment and progression judgment above, determines the measures to be implemented. The inspector or engineer makes the final determination:\n\n• A0 — No Action Required: Defect is negligible.\n• A — Monitoring Only: Monitor in subsequent inspection cycles.\n• B — Planned Maintenance: Plan regular preventive maintenance.\n• C — Repair Required (Planned): Plan repairs before the next inspection.\n• E1 — Emergency Repair Required: Structural integrity may be compromised.\n• E2 — Emergency Measures Required: Immediate traffic restrictions or temporary support work needed.\n• M — Detailed Investigation Required (Monitoring): Condition unclear; monitor carefully.\n• S1 — Detailed Investigation Required: Additional investigations such as core sampling or load testing needed.\n• S2 — Cause Investigation Required: Root cause analysis needed before determining countermeasures.\n\nThe system automatically suggests a countermeasure category based on severity grade and defect type, but inspectors may modify it based on field judgment.",
			emergencyMeasuresLongDescription: "Emergency Measures Record — MLIT Inspection Guidelines\n\nRecording is required when countermeasure category is E1 or E2. Based on \"Bridge Periodic Inspection Guidelines\" (H31/2019):\n\n・Implementation Date — Date when emergency measures were implemented.\n・Measure Content — Details of measures: traffic restrictions, temporary supports, protective barriers, speed limits, surveillance cameras, etc.\n・Implementer — Organization or person responsible for implementing the measures.\n・Permanent Measure Plan — Permanent repair plan: timing, scope, construction method.\n・Traffic Restrictions — Current ongoing traffic/passage restrictions.\n・Notification Destination — Parties notified: road manager, police, local government, etc.\n\nE1 (structural safety) requires structural measures. E2 (third-party damage) requires traffic restriction measures. Both require immediate recording and notification to road managers.",
			measureImplementationDate: "Implementation Date",
			measureContent: "Measure Content",
			measureContentPlaceholder: "e.g., Speed limit 40km/h, surveillance camera installation",
			implementer: "Implementer",
			implementerPlaceholder: "e.g., NEXCO East Japan",
			permanentMeasurePlan: "Permanent Measure Plan",
			permanentMeasurePlanPlaceholder: "e.g., Weekly monitoring, repair work within 3 months",
			trafficRestrictions: "Traffic Restrictions",
			trafficRestrictionsPlaceholder: "e.g., Heavy vehicle traffic restrictions",
			notificationDestination: "Notification Destination",
			notificationDestinationPlaceholder: "e.g., Police, local government",
			previousInspection: "Previous Inspection",
			previousSeverity: "Previous Severity",
			severityLongDescription: "Severity Grade (a–e) — MLIT Periodic Inspection Guidelines\n\nUsed to evaluate individual defects on the Field Investigation Form (Format 2) during periodic inspections. Each defect is assigned one of the following grades:\n\n• a — No Defects: No defects, or minor defects that do not affect durability or function.\n• b — Minor Defects: Defects present but do not require immediate repair. Monitoring is required.\n• c — Caution: Deterioration has progressed; countermeasures are needed to prevent functional impairment.\n• d — Emergency: Severe defects threatening structural safety or third-party safety.\n• e — Not Inspectable: Condition is not visible (debris, vegetation, etc.), or represents the worst-case state in specific defect definitions (rupture, detachment, etc.).\n\nThis assessment represents field-level \"input data.\" Together with progression assessment, it forms the basis for individual soundness ratings (I–IV) and countermeasure categories.",
			crackPattern: {
				_single: "Crack Pattern",
				longitudinal: "Longitudinal"
			},
			updated: "Updated",
			dimensions: "Dimensions",
			dimensionsLongDescription: "Defect Dimensions\n\nQuantitative measurements of defects recorded during field inspection:\n\n• Length (mm) — Dimension in the longest direction of the defect. For cracks, measured along the crack path.\n• Width (mm) — Maximum dimension perpendicular to length. For cracks, this is the crack opening width (a critical determinant for severity grading).\n• Depth (mm) — How far the defect penetrates into the concrete. Relevant for delamination, voids, and spalling.\n• Area (m²) — Total affected surface area. Relevant for delamination, leakage extent, and spalling.\n\nThese measurements are essential for severity grade (a–e) determination, tracking progression across inspection cycles, and calculating repair quantities for countermeasure planning.",
			causesLongDescription: "Defect Causes — MLIT Tunnel Defect Classification\n\nRoot cause analysis based on MLIT's tunnel defect cause categories. Multiple causes may be identified for a single defect:\n\n• Aging Deterioration — Natural degradation over time due to environmental exposure.\n• Drying Shrinkage — Early-stage cracking due to volume reduction during concrete curing.\n• Thermal Stress — Expansion/contraction cracking from temperature cycles.\n• Structural Stress — Structural cracking from overloading or design inadequacy.\n• Ground Movement — Ground settlement, heave, or lateral displacement.\n• Freeze-Thaw — Water expansion during freeze cycles causing surface scaling and popouts.\n• Water Infiltration — Water ingress through cracks or waterproofing failures.\n• Groundwater Pressure — Hydrostatic pressure from elevated groundwater levels.\n• Chloride Attack — Rebar corrosion from chloride ingress (coastal/de-icing salt environments).\n• Carbonation — CO₂ penetration reducing concrete alkalinity, promoting rebar corrosion.\n• Alkali-Silica Reaction — Chemical reaction between cement alkalis and reactive aggregates (ASR).\n• Impact Damage — Physical damage from vehicle strikes or falling debris.\n• Fire Damage — Thermal effects from tunnel fires.\n• Construction Defect — Original construction quality issues (poor compaction, cold joints, etc.).\n• Insufficient Backfill — Inadequate grouting behind the lining.\n• Joint Degradation — Deterioration of construction or expansion joints.\n• Water Erosion — Soil washout behind the lining from flowing groundwater.\n• Seismic Damage — Cracking or displacement from earthquakes.\n\nAccurate cause identification is essential for selecting effective countermeasures. Treating only symptoms without addressing root causes leads to defect recurrence.",
			causesEmptyValuePlaceholder: "No causes identified",
			notes: "Notes",
			notesPlaceholder: "Enter any additional notes about this defect record...",
			notesEmptyValuePlaceholder: "No notes, edit assessment to add notes...",
			commentPlaceholder: "Add a comment...",
			tabs: {
				photos: "Photos",
				diagram: "Diagram",
				blueprint: "Blueprint",
				"3d": "3D",
				map: "Map"
			},
			defectSummary: "Defect Summary",
			judgmentBasisPlaceholder: "Enter judgment basis for soundness rating...",
			judgmentBasisEmptyValuePlaceholder: "No judgment basis, edit assessment to add...",
			assessmentNotesPlaceholder: "Enter any additional notes about this assessment...",
			assessmentNotesEmptyValuePlaceholder: "No assessment notes, edit assessment to add notes...",
			inspectionArea: {
				emptyMessage: "No inspection areas uploaded yet.",
				uploadButton: "Upload inspection area"
			}
		},
		activities: {
			showMore: "Show {{count}} more",
			showLess: "Show less",
			comment: {
				namePlaceholder: "Your name",
				create: {
					successMessage: "Comment added successfully!"
				},
				update: {
					successMessage: "Comment updated successfully"
				},
				"delete": {
					successMessage: "Comment deleted successfully",
					confirmationTitle: "Delete Comment",
					confirmationMessage: "Are you sure you want to delete this comment? This action cannot be undone."
				}
			}
		},
		imageAlt: {
			modeled: "Modeled Defect",
			naked: "Naked Defect",
			mesh: "3D Mesh"
		},
		photos: {
			noPhotosAvailable: "No photos available"
		},
		"3d": {
			noDiagramsAvailable: "No diagrams available",
			noDiagramsAvailableForDamage: "No diagrams available for this defect record. \n Please upload a diagram through the Span.",
			goToSpan: "Go to Span",
			addMarker: {
				title: "Link to Defect Record",
				noDamages: "No defect records found for this span."
			}
		},
		filterActive: {
			tooltipSpan: "The list is being filtered at the moment. Remove filters to enable re-ordering of spans.",
			tooltipRecord: "The list is being filtered at the moment. Remove filters to enable re-ordering of defect records."
		}
	},
	inspectionItems: {
		"2d": {
			tools: {
				selector: "Select",
				linkToDefectRecord: "Link to Defect Record"
			}
		}
	},
	deliverables: {
		viewReports: "View Reports",
		damagePhotos: {
			focusModeTooltip: "View details in Inspection Items tab",
			noPhotosAvailable: "There are no photos available for this span.",
			lightbox: {
				title: "Photo Details",
				loadingError: "Failed to load photo details. Please try again.",
				previousPhoto: "Previous photo",
				nextPhoto: "Next photo"
			}
		},
		defectPhotos: {
			title: "Defect Photos",
			photoNo: "Photo No.",
			dateTaken: "Date Taken",
			memberName: "Member Name",
			elementNo: "Element No.",
			metadataEmbedded: "Metadata Embedded",
			loadingPhotos: "Loading photos… ({{count}})",
			loadingMorePhotos: "Loading more photos… ({{count}} so far)",
			loadingAllPhotos: "Loading all photos for export…",
			preparingExport: "Preparing photos for export…"
		},
		projectInfo: {
			title: "Project Info"
		}
	},
	files: {
		title: "3D Point Cloud Scan Data",
		searchPlaceholder: "Search files...",
		columns: {
			fileName: "File Name",
			scanDate: "Scan Date",
			uploadedDate: "Uploaded Date",
			fileSize: "File Size",
			pointCount: "Point Count",
			status: "Status"
		},
		add: "Add file",
		emptyState: {
			notFound: "No files match your search"
		}
	},
	facilitySummary: {
		specifications: {
			title: "Specifications"
		},
		location: {
			title: "Location"
		},
		summary: {
			totalEvents: "Total Events"
		},
		eventStats: "Event Statistics",
		eventTimeline: {
			title: "Event Timeline",
			latest: "Latest"
		}
	}
};
var property$1 = {
	id: "ID",
	kilopost: "Kilopost",
	length: "Length",
	period: "Period",
	contractor: "Contractor"
};
var phase$1 = {
	inspection: "Inspection",
	deliverables: "Deliverables",
	approval: "Approval"
};
var status$1 = {
	completed: "Completed",
	done: "Done",
	inprogress: "In Progress",
	review: "Review",
	todo: "To Do",
	archived: "Archived",
	notstarted: "Not Started",
	processed: "Processed",
	processing: "Processing",
	uploaded: "Uploaded"
};
var severity$1 = {
	previousSeverity: "Previous Severity"
};
var approval$1 = {
	pendingReview: "Pending Review",
	packageTitle: "{{year}} {{type}}",
	files: "files",
	submitter: "Submitted by",
	errors: "{{count}} errors",
	warnings: "{{count}} warnings",
	type: {
		deliverablePackage: "Deliverable Package"
	}
};
var ui$1 = {
	expand: "Expand",
	collapse: "Collapse",
	loading: "Loading...",
	uploading: "Uploading...{{progress}}%",
	close: "Close",
	cancel: "Cancel",
	confirm: "Confirm",
	attention: "Attention",
	accept: "OK",
	error: "Error",
	edit: "Edit",
	add: "Add",
	exit: "Exit",
	save: "Save",
	saving: "Saving...",
	sending: "Sending...",
	create: "Create",
	creating: "Creating...",
	"delete": "Delete",
	deleting: "Deleting...",
	unlink: "Unlink",
	unlinking: "Unlinking...",
	"export": "Export",
	pdfExport: "Export as PDF",
	moreDetails: "More details",
	viewMoreDetails: "View more details",
	moreActions: "More actions",
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	readMore: "read more",
	sendComment: "Send",
	selectAll: "Select All",
	deselectAll: "Deselect All",
	clearAllFilters: "Clear All",
	itemsSelected_one: "{{count}} selected",
	itemsSelected_other: "{{count}} selected",
	filters: "Filters",
	language: "Language",
	accountSettings: "Account Settings",
	logout: "Log out",
	noPermission: "You do not have permission to perform this action",
	none: "None",
	focusMode: "Focus Mode",
	exitFocusMode: "Exit Focus Mode",
	dontRemindAgain: "Don't remind again",
	menu: "Menu",
	open: "Open",
	viewDetails: "View details",
	zoomIn: "Zoom in",
	zoomOut: "Zoom out",
	zoomReset: "Reset zoom",
	openInEditor: "Open in Editor"
};
var user$1 = {
	subscription: {
		expiredAlert: {
			title: "No active subscription",
			description: "You are not able to access certain features because your subscription is inactive. To access all features, please upgrade your subscription. If you have any questions, contact support."
		},
		expiringWarning: {
			title: "Subscription expiring",
			description: "Your subscription is about to end and your construction data will be deleted. Renewal is required to keep your data. Please contact support or your account representative."
		}
	}
};
var errors$1 = {
	common: "An error occurred. Please try again.",
	auth0: {
		invalidToken: "Invalid authentication token. Please log in again."
	},
	aws: {
		uploadFailed: "Failed to upload file. Please check your connection and try again.",
		uploadAborted: "File upload was aborted. Please try again.",
		downloadFailed: "Failed to download file. Please check your connection and try again."
	},
	user: {
		notFound: "User not found. Please log in again.",
		fetch: "Failed to load user data. Please refresh the page and try again.",
		register: "Account registration failed. Please check your details and try again."
	},
	facility: {
		fetch: "Failed to load facilities. Please refresh the page and try again.",
		create: "Failed to create facility. Please check your input and try again.",
		"create.40301": "You do not have permission to create a facility. Please contact our support.",
		update: "Failed to update facility. Please check your input and try again.",
		"update.40301": "You do not have permission to update a facility. Please contact our support.",
		"delete": "Failed to delete facility. Please try again.",
		"delete.40301": "You do not have permission to delete a facility. Please contact our support."
	},
	span: {
		fetch: "Failed to load spans. Please refresh the page and try again.",
		create: "Failed to create span. Please check your input and try again.",
		"create.40301": "You do not have permission to create a span. Please contact our support.",
		update: "Failed to update span. Please check your input and try again.",
		"update.40301": "You do not have permission to update a span. Please contact our support.",
		"delete": "Failed to delete span. Please try again.",
		"delete.40301": "You do not have permission to delete a span. Please contact our support."
	},
	event: {
		fetch: "Failed to load events. Please refresh the page and try again.",
		create: "Failed to create event. Please check your input and try again.",
		"create.40301": "You do not have permission to create an event. Please contact our support.",
		"create.40010": "An event with the same name already exists. Please choose a different name.",
		update: "Failed to update event. Please check your input and try again.",
		"update.40301": "You do not have permission to update an event. Please contact our support.",
		"delete": "Failed to delete event. Please try again.",
		"delete.40301": "You do not have permission to delete an event. Please contact our support."
	},
	project: {
		fetch: "Failed to load projects. Please refresh the page and try again.",
		create: "Failed to create project. Please check your input and try again.",
		"create.40301": "You do not have permission to create a project. Please contact our support.",
		update: "Failed to update project. Please check your input and try again.",
		"update.40301": "You do not have permission to update a project. Please contact our support.",
		"delete": "Failed to delete project. Please try again.",
		"delete.40301": "You do not have permission to delete a project. Please contact our support.",
		inviteUser: "Failed to invite user to project. Please check the email address and try again.",
		"inviteUser.40301": "You do not have permission to invite users to this project. Please contact our support.",
		"inviteUser.40402": "The invited viewer does not have an account yet. Please invite them to create an account first.",
		removeUser: "Failed to remove user from project. Please try again.",
		"removeUser.40301": "You do not have permission to remove users from this project. Please contact our support."
	},
	damagePhoto: {
		fetch: "Failed to load damage photos. Please refresh the page and try again.",
		uploadUrl: "Failed to get upload URLs. Please try again.",
		"uploadUrl.40301": "You do not have permission to upload photos. Please contact our support.",
		upload: "Failed to upload photos. Please try again.",
		"upload.40301": "You do not have permission to upload photos. Please contact our support.",
		create: "Failed to create photo records. Please try again.",
		"create.40301": "You do not have permission to create photo records. Please contact our support.",
		update: "Failed to update photo. Please try again.",
		"update.40301": "You do not have permission to update a photo. Please contact our support.",
		"delete": "Failed to delete photo. Please try again.",
		"delete.40301": "You do not have permission to delete a photo. Please contact our support."
	},
	damage: {
		fetch: "Failed to load defect records. Please refresh the page and try again.",
		create: "Failed to create defect record. Please check your input and try again.",
		"create.40301": "You do not have permission to create a defect record. Please contact our support.",
		update: "Failed to update defect record. Please check your input and try again.",
		"update.40301": "You do not have permission to update a defect record. Please contact our support."
	},
	damageAssessment: {
		fetch: "Failed to load damage assessment. Please refresh the page and try again.",
		create: "Failed to create damage assessment. Please check your input and try again.",
		"create.40301": "You do not have permission to create a damage assessment. Please contact our support.",
		update: "Failed to update damage assessment. Please check your input and try again.",
		"update.40301": "You do not have permission to update a damage assessment. Please contact our support."
	},
	spanAssessment: {
		fetch: "Failed to load span assessment. Please refresh the page and try again.",
		create: "Failed to create span assessment. Please check your input and try again.",
		"create.40301": "You do not have permission to create a span assessment. Please contact our support.",
		update: "Failed to update span assessment. Please check your input and try again.",
		"update.40301": "You do not have permission to update a span assessment. Please contact our support.",
		"delete": "Failed to delete span assessment. Please try again.",
		"delete.40301": "You do not have permission to delete a span assessment. Please contact our support."
	},
	assessmentComment: {
		fetch: "Failed to load comments. Please refresh the page and try again.",
		create: "Failed to add comment. Please try again.",
		"create.40301": "You do not have permission to add comments. Please contact our support.",
		update: "Failed to update comment. Please try again.",
		"update.40301": "You do not have permission to update comments. Please contact our support.",
		"delete": "Failed to delete comment. Please try again.",
		"delete.40301": "You do not have permission to delete comments. Please contact our support."
	},
	inspectionArea: {
		fetch: "Failed to load inspection areas. Please refresh the page and try again.",
		create: "Failed to create inspection area. Please check your input and try again.",
		"create.40301": "You do not have permission to create an inspection area. Please contact our support.",
		"create.40011": "An inspection area with the same name already exists. Please use a different name.",
		update: "Failed to update inspection area. Please check your input and try again.",
		"update.40301": "You do not have permission to update an inspection area. Please contact our support.",
		"delete": "Failed to delete inspection area. Please try again.",
		"delete.40301": "You do not have permission to delete an inspection area. Please contact our support."
	},
	jobs: {
		get: "Failed to load background jobs. Please refresh the page and try again.",
		ack: "Failed to acknowledge the job. Please try again."
	},
	maskingRegion: {
		create: "Failed to save the mask region. Please try again.",
		fetch: "Failed to load mask regions. Please refresh the page and try again.",
		"delete": "Failed to delete the mask region. Please try again.",
		"delete.40301": "You do not have permission to delete mask regions. Please contact support."
	},
	serviceStatus: {
		fetch: "Failed to load service status. Please refresh the page and try again."
	},
	tutorialVideoConfig: {
		fetch: "Failed to load tutorial video configuration. Please refresh the page and try again."
	},
	featureFlags: {
		fetch: "Failed to load feature flags. Please refresh the page and try again."
	},
	validation: {
		fieldRequired: "This field is required",
		emergencyMeasuresRequired: "Please fill in all required emergency measures fields"
	},
	diagramDrawing: {
		fetch: "Failed to load diagrams. Please refresh the page and try again.",
		upload: "Failed to upload diagram. Please check your file and try again.",
		"upload.40301": "You do not have permission to upload diagrams. Please contact support.",
		update: "Failed to update diagram. Please check your input and try again.",
		"update.40301": "You do not have permission to update this diagram. Please contact support.",
		"delete": "Failed to delete diagram. Please try again.",
		"delete.40301": "You do not have permission to delete this diagram. Please contact support."
	}
};
var inspectionItem$1 = {
	elementList: {
		title: "Element List",
		noData: "No elements available."
	}
};
var notFound$1 = {
	heading: "The page you are looking for was not found",
	body: "The page you tried to access may have been moved or deleted. \nPlease check the URL and try again from the home page.",
	home: "Return to Home"
};
var errorPage$1 = {
	heading: "An unexpected error occurred",
	body: "Something went wrong on our end and we could not complete your request. Please try reloading the page or come back in a moment. If the problem persists, contact support with the reference number below.",
	referenceNumber: "Reference Number",
	reload: "Reload",
	home: "Return to Home"
};
var enTranslation = {
	hatsuly: hatsuly$1,
	maintenance: maintenance$1,
	nav: nav$1,
	dashboard: dashboard$1,
	userAccount: userAccount$1,
	object: object$1,
	modal: modal$1,
	section: section$1,
	property: property$1,
	phase: phase$1,
	status: status$1,
	severity: severity$1,
	approval: approval$1,
	ui: ui$1,
	user: user$1,
	errors: errors$1,
	inspectionItem: inspectionItem$1,
	"3d": {
	buttons: {
		save: "Save",
		saveAndExit: "Save and finish",
		reset: "Reset all",
		cancel: "Cancel",
		undo: "Undo last point",
		complete: "Complete drawing"
	},
	unsavedGuard: {
		title: "Unsaved work",
		body: "This will discard your unsaved work. Continue?",
		confirm: "Discard and continue"
	},
	linking: {
		linkOrModel: "Link or model inspection items to the selected defect record."
	},
	settings: {
		title: "Settings",
		display: "Display",
		visibility: "Show / hide",
		pointCloud: {
			title: "Point cloud",
			pointSize: "Point size",
			opacity: "Opacity",
			backgroundColor: "Background",
			labelSize: "Label size"
		},
		mesh: {
			title: "3D mesh",
			opacity: "Opacity",
			unavailable: "None of the shown areas has a finished 3D mesh"
		},
		maskRegions: {
			title: "Mask regions",
			showAllPoints: "Show all points",
			region: "Mask region {{index}}",
			empty: "No mask regions",
			deleteConfirmTitle: "Mask region",
			deleteConfirmMessage: "Once deleted, a mask region cannot be restored."
		},
		openDrawer: "3D display settings",
		saveSuccess: "3D display settings saved"
	},
	cameraProfile: {
		saveSuccess: "Camera profile saved",
		saveError: "Failed to save camera profile",
		specifyFront: "Next step",
		enable: "Set front view",
		disable: "Exit front view setup",
		view: {
			front: "Move camera to front (-y) view",
			back: "Move camera to back (+y) view",
			left: "Move camera to left (-x) view",
			right: "Move camera to right (+x) view",
			top: "Move camera to top (+z) view",
			bottom: "Move camera to bottom (-z) view"
		},
		backToFront: "Back to front editing"
	},
	editorTools: {
		move: "Move / Select"
	},
	link: {
		saveLink: "Save link",
		cancelAndExit: "Cancel and exit"
	},
	planeDetection: {
		tool: "Plane Detection — trace a surface to measure its area",
		detectAndLink: "Detect and Link",
		closeTooltip: "Complete this plane",
		startedTitle: "Plane detection started",
		startedBody: "Plane detection is in progress. You can keep using other tools while it runs; we'll notify you when it's done.",
		saveSuccess: "Plane detection completed",
		savedItem: "Saved \"{{itemName}}\"",
		savedAndLinked: "Saved \"{{itemName}}\" and linked it to defect record \"{{damageName}}\"",
		saveError: "Plane detection failed",
		autoLinkNote: "This plane will be auto-linked to Defect Record \"{{damageName}}\"",
		alreadyLinkedWarning: "Defect Record \"{{damageName}}\" already links another item. Saving will overwrite it.",
		detectionInProgress: "Plane detection is in progress for this defect record. Please wait for it to finish.",
		gate: {
			noRecord: "No defect record selected to link to",
			noPermission: "You don't have permission to detect / link areas",
			inProgress: "Plane detection is in progress for this defect record",
			notReady: "The scan isn't ready for detection yet"
		}
	},
	focus: {
		tool: "Focus — click a point to re-centre the camera",
		item: "Focus on item"
	},
	itemCameraProfile: {
		edit: "Set item camera profile",
		disable: "Exit item camera profile setup"
	},
	polyline: {
		tool: "Line",
		save: "Save",
		closeTooltip: "Click here to finish the line",
		saveSuccess: "Line saved",
		savedItem: "Saved \"{{itemName}}\"",
		savedAndLinked: "Saved \"{{itemName}}\" and linked it to defect record \"{{damageName}}\"",
		saveError: "Failed to save the line",
		autoLinkNote: "This length will be auto-linked to defect record \"{{damageName}}\"",
		alreadyLinkedWarning: "Defect record \"{{damageName}}\" already links another item. Saving will overwrite it.",
		width: "Width",
		widthPanelTitle: "Line settings",
		labelSection: "Label display (editing)",
		labelPrimary: "Total length",
		labelEdge: "Each segment",
		vertex: {
			add: "Add vertex",
			move: "Move vertex",
			remove: "Remove vertex",
			removeSplit: "Remove vertex / cut edge",
			connect: "Connect vertices (merge two lines)"
		},
		gate: {
			noRecord: "No defect record selected to link to",
			noPermission: "You don't have permission to save / link lengths",
			notReady: "The scan isn't ready to save yet"
		}
	},
	customMeasurement: {
		tool: "Distance — measure between two points",
		saveError: "Failed to save the distance",
		notReady: "The scan isn't ready to save yet",
		deleteError: "Failed to delete the distance",
		deleteConfirmTitle: "Delete this distance?",
		deleteConfirmMessage: "Deleting it permanently removes this measurement."
	},
	mask: {
		tool: "Mask — set the mask regions",
		saveSuccess: "Saved the mask region",
		transform: {
			translate: "Move",
			scale: "Size",
			rotate: "Rotate"
		}
	},
	elementList: {
		groups: {
			add: "Add an inspection group",
			namePlaceholder: "Group name",
			nameRequired: "Enter a group name",
			nameTaken: "That group name is already in use",
			deleteConfirmTitle: "Delete the inspection group",
			deleteConfirmMessage: "Only the group is deleted. The elements in it move back to unlabeled elements."
		},
		coloringDialog: {
			title: "Change how elements are colored",
			body1: "With the current automatic coloring setting, adding an inspection group switches coloring from the element's type color to its inspection group's color.",
			body2: "In inspection group color mode, elements are colored by their group, or with the unlabeled color when they belong to none.",
			body3: "Switch automatically, or keep coloring by element type? You can change this setting at any time from the display settings.",
			body4: "The inspection group is added either way — only the coloring behaviour differs.",
			keepElementColoring: "Keep element type colors",
			useGroupColoring: "Switch to inspection group colors"
		}
	}
},
	notFound: notFound$1,
	errorPage: errorPage$1
};

var hatsuly = {
	nav: {
		projectList: "工事一覧",
		projectSettings: "工事設定",
		login: "ログイン",
		register: "新規登録"
	},
	landing: {
		headline: "点検から、補修、\n維持管理まで、\n3Dが繋ぐ、\nインフラ管理の新しい形。",
		start: "はじめる"
	},
	register: {
		title: "新規閲覧用アカウント登録",
		description: "ここにメールアドレスを入力していただくと、工事閲覧用の無償アカウントが新規作成されます。\n工事作成などの有償機能をご利用のお客様は閲覧用アカウントでログイン後、問い合わせページよりお問い合わせください。",
		email: "メールアドレス",
		name: "氏名",
		company: "会社名",
		submit: "登録",
		successTitle: "ユーザーアカウント登録に成功しました。",
		successBody: "メールの受信箱を確認し、パスワードを設定するためのリンクを取得してください。"
	},
	adminViewBanner: {
		viewing: "{{user}} のダッシュボードを閲覧中（読み取り専用）",
		back: "自分のダッシュボードに戻る"
	},
	userMenu: {
		plan: "利用プラン",
		userList: "ユーザー一覧"
	},
	stats: {
		storageUsed: "ストレージ使用量",
		projectCount: "工事数",
		projectCountUnit: "件",
		projectBreakdown: "作成 {{owned}} ・ 招待 {{invited}}"
	},
	tabs: {
		owned: "作成した工事",
		invited: "招待された工事"
	},
	projectList: {
		searchPlaceholder: "工事を検索",
		empty: "該当する工事がありません",
		viewersUnit: "名",
		create: "新規工事作成",
		toggleAreas: "検査エリアの表示切り替え"
	},
	area: {
		searchPlaceholder: "エリアを検索",
		empty: "該当するエリアがありません",
		create: "新規エリア作成"
	},
	menu: {
		projectEdit: "工事編集",
		reportDetail: "帳票詳細",
		manageViewers: "閲覧ユーザー管理",
		projectDelete: "工事削除",
		areaEdit: "エリア編集",
		openViewer: "検査ビューアを開く",
		reportExport: "帳票出力",
		alignArea: "位置合わせ",
		areaDelete: "エリア削除"
	},
	subscription: {
		upgradeTitle: "新しい工事を作成するにはアップグレードが必要です",
		upgradeBody: "有償プランで工事の作成・ストレージ拡張・点群処理などすべての機能をご利用いただけます。",
		viewPlans: "有償プランを見る"
	},
	toast: {
		project: {
			created: "工事を作成しました",
			updated: "工事を変更しました",
			deleted: "工事を削除しました"
		},
		area: {
			created: "エリアを作成しました",
			updated: "エリアを変更しました",
			deleted: "エリアを削除しました"
		},
		viewers: {
			invited: "閲覧ユーザーを招待しました",
			removed: "閲覧ユーザーを削除しました"
		}
	},
	columns: {
		name: "名称",
		size: "サイズ",
		viewers: "閲覧ユーザー",
		updated: "更新日",
		created: "作成日"
	},
	modal: {
		project: {
			create: {
				title: "工事を作成",
				nameLabel: "工事名",
				workTypeLabel: "工種名",
				typeLabel: "種別",
				fieldHint: "エリア作成時の初期値として使用されます。エリア毎に変更可能です。"
			},
			edit: {
				title: "工事を編集"
			},
			duplicateError: "同じ工事名が既に存在します。別の名前を選択してください。",
			"delete": {
				title: "工事を削除",
				body: "「{{name}}」を削除しますか？この操作は取り消せません。"
			}
		},
		area: {
			add: {
				title: "エリアを追加",
				projectLabel: "工事",
				nameLabel: "エリア名",
				dataSection: "データ",
				pointCloud: "点群データ",
				pointCloudFormats: ".las / .laz / .ply",
				mesh: "3Dメッシュデータ",
				meshFormats: ".zip",
				chooseFile: "ファイルを選択",
				orDrop: " またはドロップ",
				inspectionSection: "検査情報",
				optional: "任意",
				workTypeLabel: "工種名",
				typeLabel: "種別",
				authorLabel: "作成者",
				createdDateLabel: "作成日",
				witnessLabel: "立会者",
				witnessDateLabel: "立会日"
			},
			edit: {
				title: "エリアを編集",
				shapesExistError: "既に検出された鉄筋または平面があります。まず削除してください。"
			},
			"delete": {
				title: "エリアを削除",
				body: "「{{name}}」を削除しますか？この操作は取り消せません。"
			}
		},
		viewers: {
			title: "閲覧ユーザー一覧",
			emailColumn: "メールアドレス",
			invite: "閲覧ユーザーを招待",
			inviteEmailLabel: "招待するメールアドレス",
			emailPlaceholder: "name@example.com",
			send: "送信",
			empty: "閲覧ユーザーがいません"
		},
		tos: {
			agree: "同意して続ける"
		}
	},
	footer: {
		copyright: "© 2024 DataLabs株式会社",
		manual: "ユーザーマニュアル",
		terms: "利用規約",
		contact: "お問い合わせ"
	},
	userList: {
		columns: {
			user: "ユーザー",
			hubspot: "HubSpot 連携",
			subscriptionEnd: "サブスク終了日",
			billing: "請求 / 代理店"
		},
		sortNext: "クリックで並び順を切り替え（降順 → 昇順 → 並び替えなし）",
		sortUnsorted: "並び替えなし（クリックでサブスク終了日の降順）",
		searchPlaceholder: "Auth0 Email (アプリログイン用) で検索",
		clearSearch: "検索をクリア",
		editHubspotId: "HubSpot ID を編集",
		refetch: "再取得",
		save: "変更を保存",
		saved: "変更を保存しました",
		saveError: "変更の保存に失敗しました",
		unsaved: "未保存",
		undoChange: "この変更を取り消す",
		hubspotIdPlaceholder: "HubSpot ID",
		noHubspotId: "ID 未設定",
		noHubspotEmail: "メール未連携",
		noInfo: "情報なし",
		legacyPlan: "旧プラン: {{plan}}",
		prevPage: "前へ",
		nextPage: "次へ",
		empty: "該当するユーザーがいません"
	}
};
var maintenance = {
	heading: "ただいまメンテナンス中です",
	body: "システムのメンテナンスを実施しているため、現在ご利用いただけません。ご不便をおかけしますが、完了までしばらくお待ちください。",
	about: "3D InfraLoopについて"
};
var nav = {
	hierarchy: "発注者 → 路線 → 施設 → イベント",
	administrators: "発注者",
	routes: "路線"
};
var dashboard = {
	_single: "ダッシュボード",
	title: "インフラダッシュボード",
	subtitle: "全施設・点検イベントの概要",
	sections: {
		recentEvents: "最近のイベント",
		attentionRequired: "対応が必要な施設",
		allFacilities: "すべての施設"
	},
	returnToDashboard: "ダッシュボードに戻る",
	attentionRequired: {
		emptyState: "現在、対応が必要な施設はありません。"
	},
	allFacilities: {
		emptyState: "施設はありません。"
	},
	recentEvents: {
		emptyState: "イベントはありません。"
	}
};
var userAccount = {
	account: {
		title: "アカウント"
	},
	inspectionSheet: {
		title: "帳票詳細"
	},
	editor: {
		title: "3D画面設定"
	},
	plan: {
		title: "請求情報"
	},
	comingSoon: {
		title: "準備中",
		description: "「{{label}}」の設定は近日公開予定です。"
	},
	backToDashboard: "ダッシュボードに戻る"
};
var object = {
	facility: {
		_single: "施設",
		list: "施設一覧",
		add: "施設を追加",
		name: "施設名",
		id: "施設ID",
		year: "竣工年",
		kilopostStart: "起点キロポスト",
		kilopostEnd: "終点キロポスト",
		type: {
			_single: "施設種別",
			tunnel: "トンネル",
			bridge: "橋梁",
			culvert: "カルバート",
			shed: "シェッド",
			overpass: "高架橋",
			other: "その他"
		},
		latitude: "緯度",
		longitude: "経度",
		coordinates: "座標",
		prefectureCode: "都道府県コード",
		municipalityCode: "市区町村コード",
		address: "住所",
		coordinateSystem: "座標系",
		totalLength: "延長 (m)",
		groundwaterCondition: "湧水状況",
		landslideArea: "地すべり地域",
		expansiveGround: "膨張性地盤",
		harmfulWater: "有害な地下水",
		snowArea: "積雪地域",
		saltDamageArea: "塩害地域",
		width: "幅員",
		height: "高さ",
		totalSpanCount: "総径間数",
		liningType: "覆工形式",
		lanes: "車線数",
		constructionMethod: "施工方法",
		structureType: "構造形式"
	},
	facilities: "施設",
	span: {
		_single: "径間",
		add: "径間を追加",
		length: "長さ",
		notes: "メモ",
		inspectionDate: "点検日",
		judgmentBasis: "判定根拠",
		assessmentNotes: "評価メモ"
	},
	event: {
		_single: "イベント",
		_plural: "イベント",
		count_one: "{{count}}件のイベント",
		count_other: "{{count}}件のイベント",
		add: "イベントを追加",
		name: "イベント名",
		year: "年度",
		period: "工期",
		contractor: "施工者",
		fiscalYear: "会計年度",
		inspectionPeriod: "点検期間",
		contractorName: "受注者名",
		contractorCode: "受注者コード",
		inspectionMethod: "点検方法",
		inspectionEquipment: "点検機材",
		weatherSummary: "天候概要",
		inspectionTeam: "点検チーム",
		previousSoundness: "前回健全度",
		soundnessRatingBasis: "健全度評価根拠",
		team: {
			role: "役職",
			name: "氏名",
			qualification: "資格",
			qualificationId: "資格ID"
		}
	},
	eventType: {
		_single: "イベント種別",
		periodic: "定期点検",
		emergency: "緊急点検",
		follow_up: "追跡点検",
		repair: "補修工事"
	},
	inspectionStatus: {
		_single: "点検ステータス",
		draft: "下書き",
		inProgress: "進行中",
		completed: "完了",
		submitted: "提出済み"
	},
	defectRecord: {
		_single: "変状記録",
		add: "変状記録を追加",
		name: "変状記録名",
		elementNumber: "要素番号"
	},
	defectPhotos: {
		memo: "メモ"
	},
	construction: {
		type: "工種名",
		creator: "作成者",
		created_date: "作成日",
		observer: "立会者",
		observed_date: "立会日"
	},
	inspectionItems: {
		_single: "点検項目",
		list: "変状一覧"
	},
	inspectionArea: {
		_single: "検査エリア",
		_plural: "検査エリア",
		name: "エリア名"
	},
	electronicDelivery: {
		_single: "電子納品"
	},
	deliverables: {
		_single: "成果品",
		_plural: "成果品"
	},
	approval: {
		_single: "承認",
		pending: "確認待ち",
		approved: "承認済み",
		rejected: "却下",
		submitted: "提出済み",
		registered: "登録済み",
		draft: "下書き",
		revisionRequested: "修正依頼"
	},
	files: {
		_single: "ファイル",
		noPCD: "点群なし",
		status: {
			running: "変換中",
			succeeded: "変換完了",
			failed: "エラー"
		}
	},
	componentType: {
		_single: "部材種類",
		tunnel: {
			crown: "アーチ部",
			sidewall: "側壁部",
			invert: "インバート",
			portal: "坑門部",
			ceiling: "天井板",
			attachments: "付属物"
		},
		bridge: {
			mainGirder: "主桁",
			crossBeam: "横桁",
			stringer: "縦桁",
			deckSlab: "床版",
			superstructureOther: "その他（上部構造）",
			pier: "橋脚",
			abutment: "橋台",
			foundation: "基礎",
			substructureOther: "その他（下部構造）",
			bearing: "支承部",
			connectionOther: "その他（上下部接続部）",
			expansionJoint: "伸縮装置",
			failSafe: "落橋防止構造",
			curb: "地覆",
			guardrail: "高欄・防護柵",
			drainage: "排水装置",
			pavement: "路面・舗装",
			staircase: "階段部",
			signBoard: "標識板",
			lighting: "照明施設",
			inspectionGallery: "検査路"
		}
	},
	assessment: {
		_single: "評価",
		_plural: "評価"
	},
	defectType: {
		_single: "変状種類",
		tunnel: {
			crack: "ひび割れ",
			delamination: "うき",
			spalling: "はく離",
			falloff: "はく落",
			deformation: "変形",
			waterLeakage: "漏水",
			materialDeterioration: "材質劣化",
			rebarExposure: "鉄筋露出",
			cavityVoid: "空洞",
			efflorescence: "エフロレッセンス",
			freeLime: "遊離石灰",
			rustStaining: "さび汁",
			honeycombing: "豆板"
		},
		bridge: {
			corrosionSteel: "腐食",
			crackSteel: "亀裂",
			boltLooseningFalloff: "ゆるみ・脱落",
			ruptureSteel: "破断",
			anticorrosionDeterioration: "防食機能の劣化",
			crackConcrete: "ひびわれ",
			spallingRebarExposure: "剥離・鉄筋露出",
			leakageEfflorescence: "漏水・遊離石灰",
			punchingFailure: "抜け落ち",
			reinforcementDamage: "補修・補強材の損傷",
			crackDeckSlab: "床版ひびわれ",
			delamination: "うき",
			jointAbnormality: "遊間の異常",
			roadSurfaceUnevenness: "路面の凹凸",
			pavementAnomaly: "舗装の異常",
			bearingDysfunction: "支承部の機能障害",
			other: "その他",
			anchorageAbnormality: "定着部の異常",
			materialDeterioration: "変色・劣化",
			waterLeakagePuddling: "漏水・滞水",
			abnormalSoundVibration: "異常な音・振動",
			abnormalDeflection: "異常なたわみ",
			deformationDefect: "変形・欠損",
			sedimentClogging: "土砂詰まり",
			settlementTilt: "沈下・移動・傾斜",
			scour: "洗掘",
			none: "損傷なし"
		}
	},
	severity: {
		_single: "変状程度",
		a: "損傷なし",
		b: "軽微",
		c: "要注意",
		d: "危険",
		e: "調査不能",
		grade: "変状程度",
		descriptions: {
			a: "損傷なし",
			b: "欠損はあるが、直ちに補修を要しない。経過観察が必要。",
			c: "劣化が進行しており、機能障害を防ぐための対策が必要。",
			d: "構造安全性または第三者への危険を脅かす重大な損傷。",
			e: "調査不能"
		}
	},
	severityChange: {
		_single: "変状程度の変化",
		worsened: "悪化",
		improved: "改善",
		unchanged: "変化なし"
	},
	progression: {
		_single: "進行状況",
		progressive: "進行性",
		stable: "横ばい",
		unknown: "不明"
	},
	countermeasure: {
		_single: "措置区分",
		A0: "措置不要",
		A: "監視のみ",
		B: "計画的補修",
		C: "補修要（計画的）",
		E1: "緊急補修要",
		E2: "緊急措置要",
		M: "詳細調査要（監視）",
		S1: "詳細調査要",
		S2: "原因調査要",
		description: {
			A0: "損傷は無視できるレベルで、措置・監視不要。",
			A: "次回以降の点検サイクルで経過観察。",
			B: "経過観察しながら計画的な維持管理を実施。",
			C: "次回点検までに補修を計画。",
			E1: "構造の健全性が損なわれている可能性。緊急補修が必要。",
			E2: "即座の交通規制や仮設支保工が必要。",
			M: "状態が不明確。注意深く監視し、詳細調査を計画。",
			S1: "コア採取、載荷試験等の追加調査が必要。",
			S2: "対策決定前に原因分析が必要。"
		}
	},
	measurements: {
		length: "長さ",
		width: "幅",
		depth: "深さ",
		area: "面積",
		volume: "体積",
		pattern: "パターン",
		displacement: "変位量",
		direction: "方向",
		level: "レベル",
		flow_state: "流出状態",
		corrosion_grade: "腐食度",
		diameter: "直径",
		corrosion_area: "腐食面積",
		thickness_reduction: "板厚減少",
		crack_length: "き裂長",
		bolt_count: "本数",
		deteriorated_area: "劣化面積",
		crack_width: "ひびわれ幅",
		efflorescence_seepage: "遊離石灰・漏水",
		exposure_area: "露出範囲",
		section_loss: "断面欠損",
		leakage_state: "漏水状態",
		hole_area: "抜け落ち面積",
		material_type: "補強材種別",
		crack_pattern: "ひびわれ形態",
		delamination_area: "うき面積",
		gap_width: "遊間",
		level_difference: "段差",
		anomaly_type: "異常種別",
		dysfunction_state: "機能障害",
		description: "説明",
		damage_state: "損傷状態",
		scour_depth: "洗掘深さ"
	},
	soundnessRating: {
		_single: "健全度",
		I: "健全",
		II: "予防保全段階",
		III: "早期措置段階",
		IV: "緊急措置段階",
		descriptions: {
			I: "重大な損傷は認められず、健全な状態。定期的な経過観察が推奨されます。",
			II: "軽微な損傷あり。予防保全措置が必要。",
			III: "機能に支障が生じる可能性があり、次回点検までに措置が必要。",
			IV: "機能に支障が生じている、または生じる可能性が著しく高く、緊急に措置を講ずべき。"
		}
	}
};
var modal = {
	facility: {
		namePlaceholder: "施設名を入力",
		typePlaceholder: "種別を選択...",
		idPlaceholder: "例: 38.45123,140.89456",
		add: {
			title: "新規施設",
			submit: "施設を作成",
			successMessage: "施設が正常に作成されました。"
		},
		edit: {
			title: "施設情報編集",
			successMessage: "施設が正常に更新されました。",
			basicInfo: "基本情報",
			location: "位置情報",
			specifications: "仕様",
			groundConditions: "地盤条件"
		},
		"delete": {
			confirmationTitle: "施設を削除",
			confirmationMessage: "この施設を削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "施設が正常に削除されました。"
		}
	},
	span: {
		nameLabel: "径間名",
		namePlaceholder: "径間名を入力",
		lengthPlaceholder: "径間長さを入力",
		notesPlaceholder: "追加情報を入力",
		add: {
			title: "径間を追加",
			submit: "径間を追加",
			successMessage: "径間が正常に追加されました。",
			tabs: {
				createNew: "新規作成",
				selectExisting: "既存を選択"
			},
			selectExistingDescription: "この点検にまだ追加されていない施設の径間をインポートします。",
			noExisting: "施設のすべての径間は既にこの点検に追加されています。",
			importSuccessMessage: "径間が正常にインポートされました。"
		},
		edit: {
			title: "径間編集",
			submit: "径間を更新",
			successMessage: "径間が正常に更新されました。"
		},
		"delete": {
			confirmationTitle: "径間を削除",
			confirmationMessage: "この径間を削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "径間が正常に削除されました。"
		}
	},
	damagePhoto: {
		upload: {
			successMessage: "写真をアップロードしました"
		},
		updateMemoSuccessMessage: "メモを更新しました",
		deleteSuccessMessage: "写真を削除しました"
	},
	defectRecord: {
		namePlaceholder: "例: 部材A-1",
		elementNumberPlaceholder: "例: 要素001",
		componentTypePlaceholder: "部材種類を選択",
		defectTypePlaceholder: "変状種類を選択",
		add: {
			title: "変状記録を追加",
			selectExistingDescription: "既存の変状記録から選択...",
			noExisting: "この径間の過去の点検イベントに既存の変状記録がありません。",
			missingInspectionDate: "点検日未記録",
			successMessage: "変状記録が正常に追加されました!",
			tabs: {
				createNew: "新規作成",
				selectExisting: "既存を選択"
			}
		},
		edit: {
			title: "変状記録を編集",
			warningMessage: "変状記録の変更は、すべての点検イベントでこの変状記録に影響します",
			successMessage: "変状記録が正常に更新されました!"
		}
	},
	event: {
		add: {
			title: "新規イベント",
			selectZipFile: "電子納品ZIPファイルを選択",
			namePlaceholder: "イベント名を入力",
			eventTypePlaceholder: "種別を選択",
			contractorPlaceholder: "施工者名を入力",
			periodPlaceholder: "例: 2026/01/01 - 2026/03/31",
			electronicDeliveryHelperText: "電子納品ZIPアーカイブから成果品フォルダ構成を取り込みます",
			successMessage: "イベントが正常に作成されました。"
		},
		edit: {
			title: "点検イベント編集",
			successMessage: "イベントが正常に更新されました。",
			basicInfo: "基本情報",
			year: "年度",
			contractorInfo: "受注者情報",
			inspectionDetails: "点検詳細",
			equipmentPlaceholder: "機材名を入力",
			addItem: "項目を追加",
			weatherSummaryPlaceholder: "例: 晴れ～曇り（点検期間中降雨なし）",
			addMember: "メンバーを追加",
			team: {
				rolePlaceholder: "役職を入力",
				namePlaceholder: "氏名を入力",
				qualificationPlaceholder: "資格を入力",
				qualificationIdPlaceholder: "資格IDを入力"
			},
			soundnessAssessment: "健全度評価",
			soundnessRatingBasisPlaceholder: "健全度判定の根拠を入力..."
		},
		"delete": {
			confirmationTitle: "イベントを削除",
			confirmationMessage: "このイベントを削除してもよろしいですか？この操作は元に戻せません。",
			successMessage: "イベントが正常に削除されました。"
		}
	},
	inspectionArea: {
		add: {
			title: "検査エリアを追加",
			spanLabel: "径間",
			spanPlaceholder: "径間を選択...",
			areaNamePlaceholder: "エリア名を入力",
			areaNameDuplicateError: "同じエリア名が既に存在します。別の名前を選択してください。",
			pcdFileLabel: "点群データ",
			pcdFileHelperText: "ファイル選択 (.las, .laz, .ply)",
			pcdFilePlaceholder: "PCDファイルを選択...",
			meshFileLabel: "3Dメッシュデータ",
			meshFileHelperText: "ファイル選択 (.zip)",
			meshFilePlaceholder: "3Dメッシュファイルを選択...",
			successMessage: "エリアを作成しました"
		},
		"delete": {
			confirmationTitle: "点検エリアを削除",
			confirmationMessage: "この点検エリアを削除してもよろしいですか?この操作は元に戻せません。",
			successMessage: "エリアを削除しました"
		}
	},
	spanAssessment: {
		create: {
			successMessage: "径間評価が正常に作成されました!"
		},
		edit: {
			successMessage: "径間評価が正常に更新されました!"
		}
	},
	comment: {
		create: {
			successMessage: "コメントが追加されました!"
		}
	},
	diagram: {
		upload: {
			successMessage: "図面をアップロードしました"
		}
	},
	diagramMarker: {
		unlink: {
			confirmationTitle: "損傷記録のリンクを解除",
			confirmationMessage: "この損傷記録のリンクを解除してもよろしいですか？損傷記録自体は削除されません。"
		}
	}
};
var section = {
	overview: {
		title: "概要",
		soundness: {
			title: "総合健全度",
			subtitle: "国土交通省点検基準",
			current: "現在",
			previous: "前回",
			worsened: "悪化",
			improved: "改善",
			stable: "横ばい",
			judgmentBasis: "判定根拠"
		},
		defectBreakdown: {
			title: "変状程度別件数",
			subtitle: "程度別内訳",
			total: "合計"
		},
		actions: {
			title: "対応が必要な項目",
			itemCount: "{{count}}件",
			critical: "緊急",
			criticalDesc: "変状程度dまたは健全度IV",
			worsened: "悪化",
			worsenedDesc: "前回点検から変状程度が悪化",
			viewMoreCritical: "さらに{{count}}件の緊急変状を表示",
			viewMoreWorsened: "さらに{{count}}件の悪化変状を表示",
			position: "位置{{position}}"
		},
		context: {
			title: "点検概要",
			facilitySpecs: "施設諸元",
			spec: {
				type: "種別",
				length: "延長",
				method: "工法",
				built: "竣工",
				lanes: "車線",
				spans: "径間数"
			},
			inspectionInfo: "点検情報",
			info: {
				period: "点検期間",
				method: "点検方法",
				equipment: "使用機材",
				contractor: "点検業者",
				team: "点検担当者"
			},
			location: "位置情報",
			locationValue: "宮城県仙台市青葉区",
			mapPlaceholder: "地図（Leaflet統合待ち）"
		},
		approval: {
			title: "承認状況",
			pending: "{{count}}件未処理",
			actionRequired: "対応が必要",
			deliverablePackage: "2025年度成果品パッケージ",
			viewAll: "すべて表示"
		}
	},
	inspectionItem: {
		title: "変状記録",
		searchPlaceholder: "径間検索...",
		filters: {
			properties: "属性"
		},
		elementAlreadyLinked: "この要素は他の損傷にリンクされています",
		linkExistingConfirm: {
			title: "既存のリンク済み/モデル化済み点検項目を置き換えますか？",
			description: "選択した点検項目はすでに別の変状記録（{{otherDamageName}}）にリンクされています。\n\n現在の変状記録（{{damageName}}）に置き換えますか？"
		},
		unlinkConfirm: {
			title: "点検項目のリンクを解除しますか？",
			description: "変状記録（{{damageName}}）から点検項目のリンクを解除してもよろしいですか？この操作は元に戻せません。"
		},
		emptyState: {
			title: "点検を開始",
			description: "径間を追加して変状を記録し、この点検イベントの記録を開始します",
			action: "径間を作成",
			hint: "最初の径間を作成して開始",
			noData: "変状記録はありません。",
			notFound: "検索に一致する径間が見つかりません"
		},
		detail: {
			viewHistory: "履歴を表示",
			historyUnavailable: "この不具合が複数の点検に記録されると履歴を表示できます。",
			activity: "アクティビティ",
			activities: "アクティビティ",
			noActivities: "まだアクティビティがありません",
			personInCharge: "担当者",
			personInChargeLongDescription: "担当者\n\nこの特定の損傷記録を担当する点検者または技術者。国土交通省の定期点検ワークフローでは：\n\n・現場点検者が初期所見と変状程度を記録。\n・資格を持つ橋梁/トンネル点検技術者が評価を確認し、必要に応じて修正。\n・担当者は追跡可能性と説明責任のために点検台帳に記録。\n\n国土交通省は、点検チームの構成員が適切な資格（例：道路メンテナンス技術者、技術士等）を保有し、氏名・資格番号を点検報告書に記載することを求めています。",
			progressionLongDescription: "進行性評価（進行性判定）\n\n前回点検記録と比較して、損傷が経時的に悪化しているかを評価します。国土交通省の要領では、すべての既存損傷について進行性の判定が求められます：\n\n・進行性 ― 前回点検から明確に悪化（例：ひび割れ幅の拡大、漏水量の増加、剥離面積の拡大）。\n・横ばい ― 損傷は存在するが、前回点検サイクルから有意な変化なし。\n・不明 ― 比較のための前回点検データがない、または前回は調査不能だった箇所。\n\n進行性は変状程度の後に評価され、個別健全度の重要な判断材料となります。同じ変状程度でも、進行性の損傷は横ばいの損傷より高い健全度が付与される場合があります。",
			soundnessRatingLongDescription: "個別健全度（I〜IV）― 国土交通省 全国統一基準\n\n変状程度（a〜e）、進行性、損傷位置、部材の重要度を総合的に判断した、構造安全性に対する技術的評価です。各損傷を個別に評価（I〜IV）し、最も深刻な評価が部材・施設レベルに反映されます：\n\n・I ― 健全：損傷なし、または構造安全性に影響しない軽微な損傷。\n・II ― 予防保全段階：損傷があるが機能に支障なし。予防保全が推奨される。\n・III ― 早期措置段階：重大な損傷。次回点検前に措置が必要。\n・IV ― 緊急措置段階：構造安全性または第三者被害を脅かす深刻な損傷。即時対応が必要。\n\nIII又はIVと評価された損傷が1つでもあれば、径間・施設全体がその評価に引き上げられます。この評価が下の対策区分の根拠となります。",
			countermeasureLongDescription: "対策区分 ― 国土交通省 橋梁・トンネル点検要領\n\n上記の健全度評価と進行性判定に基づき、実施すべき措置を決定します。点検者または技術者が最終判断として判定します：\n\n・A0 ― 措置不要。損傷は無視できるレベル。\n・A ― 監視のみ。次回以降の点検サイクルで経過観察。\n・B ― 計画的補修。定期的な維持管理を計画。\n・C ― 補修要（計画的）。次回点検までに補修を計画。\n・E1 ― 緊急補修要。構造の健全性が損なわれている可能性。\n・E2 ― 緊急措置要。即座の交通規制や仮設支保工が必要。\n・M ― 詳細調査要（監視）。状態が不明確。注意深く監視。\n・S1 ― 詳細調査要。コア採取、載荷試験等の追加調査が必要。\n・S2 ― 原因調査要。対策決定前に原因分析が必要。\n\nシステムは変状程度と損傷種類に基づき対策区分を自動提案しますが、点検者は現場判断に基づき変更可能です。",
			emergencyMeasuresLongDescription: "応急措置記録 ― 国土交通省 点検要領\n\n対策区分がE1またはE2の場合に記録が必要です。「橋梁定期点検要領」（H31/2019）に基づく：\n\n・応急措置実施日 ― 応急措置を実施した日付。\n・応急措置内容 ― 実施した内容：交通規制、仮設支保工、防護柵、速度制限、監視カメラ設置等。\n・実施者 ― 措置を実施した組織または担当者。\n・恒久対策計画 ― 恒久的な補修計画：時期、範囲、工法。\n・通行制限等 ― 現在継続中の交通・通行制限。\n・通報先 ― 通報した相手：道路管理者、警察、地方自治体等。\n\nE1（構造安全性）は構造的な措置が必要です。E2（第三者被害）は交通規制措置が必要です。いずれも即座の記録と道路管理者への通報が求められます。",
			measureImplementationDate: "措置実施日",
			measureContent: "措置内容",
			measureContentPlaceholder: "例：速度制限40km/h、監視カメラ設置",
			implementer: "実施者",
			implementerPlaceholder: "例：NEXCO東日本",
			permanentMeasurePlan: "恒久対策計画",
			permanentMeasurePlanPlaceholder: "例：週次モニタリング、3ヶ月以内に補修工事",
			trafficRestrictions: "通行制限等",
			trafficRestrictionsPlaceholder: "例：大型車通行制限",
			notificationDestination: "通報先",
			notificationDestinationPlaceholder: "例：警察、地方自治体",
			previousInspection: "前回点検",
			previousSeverity: "前回変状程度",
			severityLongDescription: "変状程度（a〜e）― 国土交通省 定期点検要領\n\n定期点検時に、個々の損傷を現場調査票（様式2）で評価する際に使用します。各損傷に以下のいずれかの等級を付与します：\n\n・a ― 損傷なし：損傷がない。または耐久性・機能に影響しない軽微なもの。\n・b ― 軽微：損傷があるが、直ちに補修を必要としない。経過観察が必要。\n・c ― 要注意：構造機能に支障を及ぼす可能性があり、対策の検討が必要な状態。\n・d ― 危険：構造安全性を脅かす、または第三者被害の恐れがある緊急な状態。\n・e ― 調査不能：視認できない状態（ゴミ、植生等）。または、特定の損傷定義における最悪の状態（破断、脱落等）。\n\nこの評価は現場レベルの「入力データ」です。進行性とあわせて、個別健全度（I〜IV）および対策区分の根拠となります。",
			crackPattern: {
				_single: "ひび割れパターン",
				longitudinal: "縦方向"
			},
			updated: "更新日",
			dimensions: "寸法",
			dimensionsLongDescription: "損傷寸法\n\n現場点検時に記録する損傷の定量的な計測値：\n\n・長さ（mm）― 損傷の最長方向の寸法。ひび割れの場合、ひび割れ経路に沿って測定。\n・幅（mm）― 長さに垂直な方向の最大寸法。ひび割れの場合、ひび割れ開口幅（変状程度判定の重要な決定要因）。\n・深さ（mm）― 損傷がコンクリート内部にどれだけ貫入しているか。剥離、空洞、うきに関連。\n・面積（m²）― 影響を受けた総表面積。剥離、漏水範囲、うきに関連。\n\nこれらの計測値は変状程度（a〜e）の判定、点検サイクル間の進行性追跡、対策計画における補修数量の算出に不可欠です。",
			causesLongDescription: "損傷原因 ― 国土交通省 トンネル損傷分類\n\n国土交通省のトンネル損傷原因カテゴリに基づく原因分析。1つの損傷に対して複数の原因が特定される場合があります：\n\n・経年劣化 ― 環境暴露による経時的な自然劣化。\n・乾燥収縮 ― コンクリート硬化時の体積減少による初期ひび割れ。\n・温度応力 ― 温度サイクルによる膨張・収縮ひび割れ。\n・構造応力 ― 過荷重や設計不足による構造ひび割れ。\n・地盤変動 ― 地盤沈下、隆起、水平変位。\n・凍結融解 ― 凍結サイクルによる水の膨張で表面のスケーリングやポップアウトが発生。\n・浸水 ― ひび割れや防水不良部からの水の浸入。\n・地下水圧 ― 地下水位上昇による静水圧。\n・塩害 ― 塩分浸入による鉄筋腐食（沿岸部/凍結防止剤環境）。\n・中性化 ― CO₂浸透によるコンクリートのアルカリ性低下、鉄筋腐食を促進。\n・アルカリシリカ反応 ― セメントのアルカリと反応性骨材の化学反応（ASR）。\n・衝撃損傷 ― 車両衝突やがれきによる物理的損傷。\n・火災損傷 ― トンネル火災による熱影響。\n・施工不良 ― 元の施工品質の問題（締固め不足、コールドジョイント等）。\n・裏込め不足 ― 覆工背面の不十分なグラウト注入。\n・目地劣化 ― 施工目地や伸縮目地の劣化。\n・水食 ― 流動する地下水による覆工背面の土砂流出。\n・地震損傷 ― 地震によるひび割れや変位。\n\n正確な原因特定は効果的な対策の選定に不可欠です。根本原因に対処せず症状のみを処置すると、損傷が再発します。",
			causesEmptyValuePlaceholder: "要因が特定されていません",
			cause: {
				aging: "経年劣化",
				thermal: "温度応力"
			},
			notes: "メモ",
			notesPlaceholder: "この変状記録に関する追加メモを入力...",
			notesEmptyValuePlaceholder: "メモなし、評価を編集してメモを追加...",
			commentPlaceholder: "コメントを追加...",
			tabs: {
				photos: "写真",
				diagram: "図面",
				blueprint: "設計図",
				"3d": "3D",
				map: "地図"
			},
			defectSummary: "変状集計",
			judgmentBasisPlaceholder: "健全度判定の根拠を入力...",
			judgmentBasisEmptyValuePlaceholder: "判定根拠なし、評価を編集して追加...",
			assessmentNotesPlaceholder: "評価に関する追加メモを入力...",
			assessmentNotesEmptyValuePlaceholder: "評価メモなし、評価を編集してメモを追加...",
			inspectionArea: {
				emptyMessage: "点検エリアがまだアップロードされていません。",
				uploadButton: "点検エリアをアップロード"
			}
		},
		activities: {
			showMore: "さらに{{count}}件を表示",
			showLess: "簡略表示",
			comment: {
				namePlaceholder: "氏名",
				create: {
					successMessage: "コメントが追加されました!"
				},
				update: {
					successMessage: "コメントが更新されました"
				},
				"delete": {
					successMessage: "コメントが削除されました",
					confirmationTitle: "コメントを削除",
					confirmationMessage: "このコメントを削除してもよろしいですか？この操作は元に戻せません。"
				}
			}
		},
		imageAlt: {
			modeled: "モデル化された損傷",
			naked: "損傷写真",
			mesh: "3Dメッシュ"
		},
		photos: {
			noPhotosAvailable: "写真がありません"
		},
		"3d": {
			noDiagramsAvailable: "図面がありません",
			noDiagramsAvailableForDamage: "この変状記録に利用できる図面がありません。\n径間から図面をアップロードしてください。",
			goToSpan: "径間へ移動",
			addMarker: {
				title: "変状記録にリンク",
				noDamages: "この径間に変状記録がありません。"
			}
		},
		filterActive: {
			tooltipSpan: "現在フィルターが適用されています。フィルターを解除してから径間を並べ替えてください。",
			tooltipRecord: "現在フィルターが適用されています。フィルターを解除してから変状記録を並べ替えてください。"
		}
	},
	inspectionItems: {
		"2d": {
			tools: {
				selector: "選択",
				linkToDefectRecord: "変状記録にリンク"
			}
		}
	},
	deliverables: {
		viewReports: "レポートを表示",
		damagePhotos: {
			focusModeTooltip: "変状一覧タブで詳細を表示",
			noPhotosAvailable: "この径間に使用可能な写真はありません。",
			lightbox: {
				title: "写真詳細",
				loadingError: "写真の詳細を読み込めませんでした。再度お試しください。",
				previousPhoto: "前の写真",
				nextPhoto: "次の写真"
			}
		},
		defectPhotos: {
			title: "変状写真",
			photoNo: "写真番号",
			dateTaken: "撮影日",
			memberName: "部材名",
			elementNo: "要素番号",
			metadataEmbedded: "メタデータ埋込済",
			loadingPhotos: "写真を読み込み中… ({{count}}枚)",
			loadingMorePhotos: "写真を読み込み中… (現在{{count}}枚)",
			loadingAllPhotos: "エクスポート用に全ての写真を読み込み中…",
			preparingExport: "エクスポート用の写真を準備中…"
		},
		projectInfo: {
			title: "工事情報"
		}
	},
	files: {
		title: "3D点群スキャンデータ",
		searchPlaceholder: "ファイル検索...",
		columns: {
			fileName: "ファイル名",
			scanDate: "スキャン日",
			uploadedDate: "アップロード日",
			fileSize: "ファイルサイズ",
			pointCount: "ポイント数",
			status: "ステータス"
		},
		add: "ファイルを追加",
		emptyState: {
			notFound: "検索に一致するファイルが見つかりません"
		}
	},
	facilitySummary: {
		specifications: {
			title: "仕様"
		},
		location: {
			title: "位置情報"
		},
		summary: {
			totalEvents: "総イベント数",
			latestSoundness: "最新健全度"
		},
		eventStats: "イベント統計",
		eventTimeline: {
			title: "イベントタイムライン",
			latest: "最新"
		}
	}
};
var property = {
	id: "ID",
	kilopost: "キロポスト",
	length: "延長",
	built: "竣工",
	period: "工期",
	contractor: "受注者"
};
var phase = {
	inspection: "点検",
	deliverables: "成果品",
	approval: "承認"
};
var status = {
	completed: "完了",
	done: "完了",
	inprogress: "進行中",
	review: "レビュー",
	todo: "未着手",
	archived: "アーカイブ",
	notstarted: "未開始",
	processed: "処理済み",
	processing: "処理中",
	uploaded: "アップロード済み"
};
var severity = {
	previousSeverity: "前回変状程度"
};
var approval = {
	pendingReview: "確認待ち",
	packageTitle: "{{year}}年度 {{type}}",
	files: "ファイル",
	submitter: "提出者",
	errors: "{{count}} 件のエラー",
	warnings: "{{count}} 件の警告",
	type: {
		deliverablePackage: "成果品パッケージ"
	}
};
var ui = {
	expand: "拡大",
	collapse: "折りたたむ",
	loading: "読み込み中...",
	uploading: "アップロード中...{{progress}}%",
	close: "閉じる",
	cancel: "キャンセル",
	confirm: "確定",
	attention: "注意",
	accept: "了解",
	error: "エラー",
	edit: "編集",
	add: "追加",
	exit: "終了",
	save: "保存",
	saving: "保存中...",
	sending: "送信中...",
	create: "作成",
	creating: "作成中...",
	"delete": "削除",
	deleting: "削除中...",
	unlink: "リンク解除",
	unlinking: "リンク解除中...",
	"export": "エクスポート",
	pdfExport: "PDFエクスポート",
	moreDetails: "詳細を見る",
	viewMoreDetails: "詳細を見る",
	moreActions: "その他の操作",
	expandAll: "すべて展開",
	collapseAll: "すべて折りたたむ",
	readMore: "もっと見る",
	sendComment: "追加",
	selectAll: "すべて選択",
	deselectAll: "すべて解除",
	clearAllFilters: "すべてクリア",
	itemsSelected_one: "{{count}}件選択中",
	itemsSelected_other: "{{count}}件選択中",
	filters: "フィルター",
	language: "言語",
	accountSettings: "アカウント設定",
	logout: "ログアウト",
	noPermission: "この操作を実行する権限がありません",
	none: "なし",
	focusMode: "フォーカスモード",
	exitFocusMode: "フォーカスモードを解除",
	dontRemindAgain: "今後表示しない",
	menu: "メニュー",
	open: "開く",
	viewDetails: "詳細を見る",
	zoomIn: "ズームイン",
	zoomOut: "ズームアウト",
	zoomReset: "ズームをリセット",
	openInEditor: "エディタで開く"
};
var user = {
	subscription: {
		expiredAlert: {
			title: "有効なサブスクリプションがありません",
			description: "サブスクリプションが無効のため、一部の機能をご利用いただけません。すべての機能をご利用いただくには、サブスクリプションをアップグレードしてください。ご不明な点がある場合は、サポートまでお問い合わせください。"
		},
		expiringWarning: {
			title: "サブスクリプション有効期間",
			description: "まもなくサブスクリプションの有効期間が終了し工事データが削除されます。データを保持するためには更新が必要です。お問合せまたは弊社担当へご連絡ください。"
		}
	}
};
var errors = {
	common: "エラーが発生しました。再度お試しください。",
	auth0: {
		invalidToken: "認証トークンが無効です。再度ログインしてください。"
	},
	aws: {
		uploadFailed: "ファイルのアップロードに失敗しました。接続を確認して再度お試しください。",
		uploadAborted: "ファイルのアップロードが中止されました。再度お試しください。",
		downloadFailed: "ファイルのダウンロードに失敗しました。接続を確認して再度お試しください。"
	},
	user: {
		notFound: "ユーザーが見つかりません。再度ログインしてください。",
		fetch: "ユーザーデータの読み込みに失敗しました。ページを更新して再度お試しください。",
		register: "アカウント登録に失敗しました。入力内容を確認して再度お試しください。"
	},
	facility: {
		fetch: "施設の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "施設の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "施設を作成する権限がありません。サポートまでお問い合わせください。",
		update: "施設の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "施設を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "施設の削除に失敗しました。再度お試しください。",
		"delete.40301": "施設を削除する権限がありません。サポートまでお問い合わせください。"
	},
	span: {
		fetch: "径間の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "径間の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "径間を作成する権限がありません。サポートまでお問い合わせください。",
		update: "径間の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "径間を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "径間の削除に失敗しました。再度お試しください。",
		"delete.40301": "径間を削除する権限がありません。サポートまでお問い合わせください。"
	},
	event: {
		fetch: "イベントの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "イベントの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40010": "同じ名前のイベントが既に存在します。別の名前を選択してください。",
		"create.40301": "イベントを作成する権限がありません。サポートまでお問い合わせください。",
		update: "イベントの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "イベントを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "イベントの削除に失敗しました。再度お試しください。",
		"delete.40301": "イベントを削除する権限がありません。サポートまでお問い合わせください。"
	},
	project: {
		fetch: "プロジェクトの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "プロジェクトの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "プロジェクトを作成する権限がありません。サポートまでお問い合わせください。",
		update: "プロジェクトの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "プロジェクトを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "プロジェクトの削除に失敗しました。再度お試しください。",
		"delete.40301": "プロジェクトを削除する権限がありません。サポートまでお問い合わせください。",
		inviteUser: "プロジェクトへのユーザー招待に失敗しました。メールアドレスを確認して再度お試しください。",
		"inviteUser.40301": "このプロジェクトにユーザーを招待する権限がありません。サポートまでお問い合わせください。",
		"inviteUser.40402": "招待された閲覧ユーザーのアカウントが作成されていません。まずアカウント作成の招待を行ってください。",
		removeUser: "プロジェクトからのユーザー削除に失敗しました。再度お試しください。",
		"removeUser.40301": "このプロジェクトからユーザーを削除する権限がありません。サポートまでお問い合わせください。"
	},
	damagePhoto: {
		fetch: "損傷写真の読み込みに失敗しました。ページを更新して再度お試しください。",
		uploadUrl: "アップロードURLの取得に失敗しました。再度お試しください。",
		"uploadUrl.40301": "写真をアップロードする権限がありません。サポートまでお問い合わせください。",
		upload: "写真のアップロードに失敗しました。再度お試しください。",
		"upload.40301": "写真をアップロードする権限がありません。サポートまでお問い合わせください。",
		create: "写真レコードの作成に失敗しました。再度お試しください。",
		"create.40301": "写真レコードを作成する権限がありません。サポートまでお問い合わせください。",
		update: "写真の更新に失敗しました。再度お試しください。",
		"update.40301": "写真を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "写真の削除に失敗しました。再度お試しください。",
		"delete.40301": "写真を削除する権限がありません。サポートまでお問い合わせください。"
	},
	damage: {
		fetch: "変状記録の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "変状記録の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "変状記録を作成する権限がありません。サポートまでお問い合わせください。",
		update: "変状記録の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "変状記録を更新する権限がありません。サポートまでお問い合わせください。"
	},
	damageAssessment: {
		fetch: "変状評価の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "変状評価の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "変状評価を作成する権限がありません。サポートまでお問い合わせください。",
		update: "変状評価の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "変状評価を更新する権限がありません。サポートまでお問い合わせください。"
	},
	spanAssessment: {
		fetch: "径間評価の読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "径間評価の作成に失敗しました。入力を確認して再度お試しください。",
		"create.40301": "径間評価を作成する権限がありません。サポートまでお問い合わせください。",
		update: "径間評価の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "径間評価を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "径間評価の削除に失敗しました。再度お試しください。",
		"delete.40301": "径間評価を削除する権限がありません。サポートまでお問い合わせください。"
	},
	assessmentComment: {
		fetch: "コメントの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "コメントの追加に失敗しました。再度お試しください。",
		"create.40301": "コメントを追加する権限がありません。サポートまでお問い合わせください。",
		update: "コメントの更新に失敗しました。再度お試しください。",
		"update.40301": "コメントを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "コメントの削除に失敗しました。再度お試しください。",
		"delete.40301": "コメントを削除する権限がありません。サポートまでお問い合わせください。"
	},
	inspectionArea: {
		fetch: "検査エリアの読み込みに失敗しました。ページを更新して再度お試しください。",
		create: "検査エリアの作成に失敗しました。入力を確認して再度お試しください。",
		"create.40011": "同じ名前の検査エリアが既に存在します。別の名前を使用してください。",
		"create.40301": "検査エリアを作成する権限がありません。サポートまでお問い合わせください。",
		update: "検査エリアの更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "検査エリアを更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "検査エリアの削除に失敗しました。再度お試しください。",
		"delete.40301": "検査エリアを削除する権限がありません。サポートまでお問い合わせください。"
	},
	jobs: {
		get: "ジョブの取得に失敗しました。ページを更新して再度お試しください。",
		ack: "ジョブの確認処理に失敗しました。再度お試しください。"
	},
	maskingRegion: {
		create: "注目領域の保存に失敗しました。再度お試しください。",
		fetch: "注目領域の読み込みに失敗しました。ページを更新して再度お試しください。",
		"delete": "注目領域の削除に失敗しました。再度お試しください。",
		"delete.40301": "注目領域を削除する権限がありません。サポートまでお問い合わせください。"
	},
	serviceStatus: {
		fetch: "サービス状況の読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	tutorialVideoConfig: {
		fetch: "チュートリアル動画設定の読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	featureFlags: {
		fetch: "機能フラグの読み込みに失敗しました。ページを更新して再度お試しください。"
	},
	validation: {
		fieldRequired: "このフィールドは必須です",
		emergencyMeasuresRequired: "応急措置の必須項目をすべて入力してください"
	},
	diagramDrawing: {
		fetch: "図面の読み込みに失敗しました。ページを更新して再度お試しください。",
		upload: "図面のアップロードに失敗しました。ファイルを確認して再度お試しください。",
		"upload.40301": "図面をアップロードする権限がありません。サポートまでお問い合わせください。",
		update: "図面の更新に失敗しました。入力を確認して再度お試しください。",
		"update.40301": "図面を更新する権限がありません。サポートまでお問い合わせください。",
		"delete": "図面の削除に失敗しました。再度お試しください。",
		"delete.40301": "図面を削除する権限がありません。サポートまでお問い合わせください。"
	}
};
var inspectionItem = {
	elementList: {
		title: "要素一覧",
		noData: "データがありません"
	}
};
var notFound = {
	heading: "お探しのページは見つかりませんでした",
	body: "アクセスしようとしたページは、移動または削除された可能性があります。URL をご確認のうえ、ホームからやり直してください。",
	home: "ホームに戻る"
};
var errorPage = {
	heading: "予期しないエラーが発生しました",
	body: "システム側に問題が発生し、処理を完了できませんでした。お手数ですが、ページを再読み込みするか、しばらく時間をおいて再度お試しください。問題が解決しない場合は、下記の参照番号を添えてサポートまでご連絡ください。",
	referenceNumber: "参照番号",
	reload: "再読み込み",
	home: "ホームに戻る"
};
var jaTranslation = {
	hatsuly: hatsuly,
	maintenance: maintenance,
	nav: nav,
	dashboard: dashboard,
	userAccount: userAccount,
	object: object,
	modal: modal,
	section: section,
	property: property,
	phase: phase,
	status: status,
	severity: severity,
	approval: approval,
	ui: ui,
	user: user,
	errors: errors,
	inspectionItem: inspectionItem,
	"3d": {
	buttons: {
		save: "保存",
		saveAndExit: "保存して終了",
		reset: "全てをリセット",
		cancel: "キャンセル",
		undo: "点をひとつ戻す",
		complete: "描画中の要素を完了"
	},
	unsavedGuard: {
		title: "未保存の作業があります",
		body: "このまま進むと、作業内容は破棄されます。よろしいですか？",
		confirm: "破棄して続行"
	},
	linking: {
		linkOrModel: "検査エリアを選択して検査項目をリンクまたはモデル化"
	},
	settings: {
		title: "設定",
		display: "表示設定",
		visibility: "表示・非表示",
		pointCloud: {
			title: "点群",
			pointSize: "点のサイズ",
			opacity: "不透明度",
			backgroundColor: "背景色",
			labelSize: "ラベルサイズ"
		},
		mesh: {
			title: "3Dメッシュ",
			opacity: "不透明度",
			unavailable: "表示中のエリアに完成した3Dメッシュがありません"
		},
		maskRegions: {
			title: "注目領域",
			showAllPoints: "すべての点を表示",
			region: "注目領域 {{index}}",
			empty: "注目領域がありません",
			deleteConfirmTitle: "注目領域",
			deleteConfirmMessage: "一度削除してしまうと、元に戻せません。"
		},
		openDrawer: "3D画面の設定",
		saveSuccess: "3D画面設定が正常に保存されました"
	},
	cameraProfile: {
		saveSuccess: "カメラプロファイルを保存しました",
		saveError: "カメラプロファイルの保存に失敗しました",
		specifyFront: "正面を指定",
		enable: "正面を設定",
		disable: "カメラ正面の設定を終了",
		view: {
			front: "カメラを正面(-y)からの視点に移動",
			back: "カメラを裏(+y)からの視点に移動",
			left: "カメラを左(-x)からの視点に移動",
			right: "カメラを右(+x)からの視点に移動",
			top: "カメラを上(+z)からの視点に移動",
			bottom: "カメラを下(-z)からの視点に移動"
		},
		backToFront: "正面の編集に戻る"
	},
	editorTools: {
		move: "移動 / 選択"
	},
	link: {
		saveLink: "リンクを保存",
		cancelAndExit: "キャンセルして終了"
	},
	planeDetection: {
		tool: "平面検出 — 面をなぞって面積を計測",
		detectAndLink: "計算してリンク",
		closeTooltip: "この平面の作成を完了",
		startedTitle: "平面検出を開始しました",
		startedBody: "平面検出が進行中です。完了をお待ちの間、他のツールを引き続きご利用いただけます。完了次第、通知いたします。",
		saveSuccess: "平面検出が完了しました",
		savedItem: "「{{itemName}}」を保存しました",
		savedAndLinked: "「{{itemName}}」を保存し、欠陥記録「{{damageName}}」にリンクしました",
		saveError: "平面検出に失敗しました",
		autoLinkNote: "この平面は 欠陥記録「{{damageName}}」 に自動でリンクされます",
		alreadyLinkedWarning: "欠陥記録「{{damageName}}」には既に別の項目がリンクされています。保存すると上書きされます。",
		detectionInProgress: "この欠陥記録では平面検出が進行中です。完了までお待ちください。",
		gate: {
			noRecord: "リンク先の欠陥記録が選択されていません",
			noPermission: "面積を計算・リンクする権限がありません",
			inProgress: "この欠陥記録では平面検出が進行中です",
			notReady: "スキャンの処理が完了していないため計算できません"
		}
	},
	focus: {
		tool: "フォーカス — 点をクリックしてカメラを中心に移動",
		item: "アイテムにフォーカス"
	},
	itemCameraProfile: {
		edit: "アイテムのカメラプロファイルを設定",
		disable: "アイテムのカメラプロファイル設定を終了"
	},
	polyline: {
		tool: "延長",
		save: "保存",
		closeTooltip: "ここをクリックして線を終了",
		saveSuccess: "延長の保存が完了しました",
		savedItem: "「{{itemName}}」を保存しました",
		savedAndLinked: "「{{itemName}}」を保存し、欠陥記録「{{damageName}}」にリンクしました",
		saveError: "延長の保存に失敗しました",
		autoLinkNote: "この延長は 欠陥記録「{{damageName}}」 に自動でリンクされます",
		alreadyLinkedWarning: "欠陥記録「{{damageName}}」には既に別の項目がリンクされています。保存すると上書きされます。",
		width: "幅",
		widthPanelTitle: "延長計算の設定",
		labelSection: "ラベル表示（編集中）",
		labelPrimary: "全長",
		labelEdge: "各辺",
		vertex: {
			add: "頂点を追加",
			move: "点を移動",
			remove: "頂点を削除",
			removeSplit: "頂点を削除 / 辺を切断",
			connect: "頂点を接続（2つの延長を結合）"
		},
		gate: {
			noRecord: "リンク先の欠陥記録が選択されていません",
			noPermission: "延長を保存・リンクする権限がありません",
			notReady: "スキャンの処理が完了していないため保存できません"
		}
	},
	customMeasurement: {
		tool: "距離 — 2点間の距離を計測",
		saveError: "距離の保存に失敗しました",
		notReady: "スキャンの処理が完了していないため保存できません",
		deleteError: "距離の削除に失敗しました",
		deleteConfirmTitle: "この距離を削除しますか？",
		deleteConfirmMessage: "削除すると、この距離の計測結果は元に戻せません。"
	},
	mask: {
		tool: "注目領域の設定",
		saveSuccess: "注目領域設定の保存が完了しました",
		transform: {
			translate: "移動",
			scale: "サイズ",
			rotate: "回転"
		}
	},
	elementList: {
		groups: {
			add: "検査グループを追加",
			namePlaceholder: "グループ名",
			nameRequired: "グループ名を入力してください",
			nameTaken: "このグループ名はすでに使用されています",
			deleteConfirmTitle: "検査グループの削除",
			deleteConfirmMessage: "グループのみが削除されます。含まれる要素は未分類要素に戻ります。"
		},
		coloringDialog: {
			title: "要素の色付け動作の変更",
			body1: "現在の自動色付け設定では、検査グループを追加すると色付け動作が要素の種類の色から検査グループの色に切り替わります。",
			body2: "検査グループの色モードでは、要素はグループに基づいて色付けされるか、グループに含まれない場合は未分類用の色が使用されます。",
			body3: "自動切り替えを実行しますか？それとも要素の種類による色のままにしますか？この設定は画面設定からいつでも変更できます。",
			body4: "どちらのオプションでも検査グループを追加できますが、選択に応じて色付け動作が異なります。",
			keepElementColoring: "要素の種類による色のまま",
			useGroupColoring: "検査グループの色に切り替え"
		}
	}
},
	notFound: notFound,
	errorPage: errorPage
};

const resources = {
    en: {
        translation: enTranslation,
    },
    ja: {
        translation: jaTranslation,
    },
};
i18n
    .use(Browser)
    .use(initReactI18next)
    .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: ['en', 'ja'],
    load: 'languageOnly',
    interpolation: {
        escapeValue: false,
    },
    returnNull: false,
});
// Keep <html lang> in sync so browsers don't mis-detect and auto-translate the page.
const syncDocumentLang = (lng) => {
    if (typeof document !== 'undefined') {
        document.documentElement.lang = lng;
    }
};
syncDocumentLang(i18n.resolvedLanguage ?? i18n.language);
i18n.on('languageChanged', syncDocumentLang);

const useTranslation = () => {
    const { t, i18n } = useTranslation$1();
    const tStatus = (status) => {
        return t(`status.${status}`);
    };
    return {
        // Use the resolved language (e.g. 'en') rather than the raw detected code
        // (e.g. 'en-US'), so switchers highlight the active language even when it
        // was auto-detected and never explicitly chosen.
        language: i18n.resolvedLanguage ?? i18n.language,
        setLanguage: (lang) => i18n.changeLanguage(lang),
        t,
        tStatus,
    };
};

export { useTranslation };
//# sourceMappingURL=index.js.map
